import "./terms.4f99b699.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaa2b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaa2b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/**
 * Application configuration
 * Centralizes all environment variables and API endpoints
 */ const $d27dbe10f1bffb7d$var$isProduction = true;
const $d27dbe10f1bffb7d$var$API_BASE_URL = $d27dbe10f1bffb7d$var$isProduction ? 'https://server.ilovej1.com/api' : 'http://localhost:8080/api';
const $d27dbe10f1bffb7d$var$config = {
    isProduction: $d27dbe10f1bffb7d$var$isProduction,
    api: {
        baseUrl: $d27dbe10f1bffb7d$var$API_BASE_URL,
        esim: `${$d27dbe10f1bffb7d$var$API_BASE_URL}/esim`,
        auth: `${$d27dbe10f1bffb7d$var$API_BASE_URL}/auth`,
        checkout: `${$d27dbe10f1bffb7d$var$API_BASE_URL}/checkout`
    }
};
var $d27dbe10f1bffb7d$export$2e2bcd8739ae039 = $d27dbe10f1bffb7d$var$config;


class $42f96fa8e433dde8$var$EsimProvider {
    /**
     * @param {Object} options - Provider options
     * @param {string} options.baseUrl - API base URL (optional)
     */ constructor({ baseUrl: baseUrl } = {}){
        this.baseUrl = baseUrl || (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.esim;
        this._cache = {
            packages: new Map(),
            locations: null
        };
        this._cacheStorageKey = 'esim_provider_cache';
        this._pendingRequests = new Map();
        this._loadCacheFromStorage();
    }
    /**
     * Loads cache from localStorage
     */ _loadCacheFromStorage() {
        try {
            const stored = localStorage.getItem(this._cacheStorageKey);
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed.packages) Object.entries(parsed.packages).forEach(([key, value])=>{
                    if (value && typeof value === 'object' && !value.timestamp) value = {
                        data: value,
                        timestamp: Date.now()
                    };
                    this._cache.packages.set(key, value);
                });
                if (parsed.locations) {
                    if (parsed.locations && typeof parsed.locations === 'object' && !parsed.locations.timestamp) this._cache.locations = {
                        data: parsed.locations,
                        timestamp: Date.now()
                    };
                    else this._cache.locations = parsed.locations;
                }
            }
        } catch (error) {
            console.error('Error loading cache from storage:', error);
        }
    }
    /**
     * Saves cache to localStorage
     */ _saveCacheToStorage() {
        try {
            const packagesObj = {};
            this._cache.packages.forEach((value, key)=>{
                packagesObj[key] = value;
            });
            const toStore = {
                packages: packagesObj,
                locations: this._cache.locations
            };
            localStorage.setItem(this._cacheStorageKey, JSON.stringify(toStore));
        } catch (error) {
            console.error('Error saving cache to storage:', error);
        }
    }
    /**
     * Wraps data with timestamp for cache tracking
     * @param {*} data - Data to wrap
     * @returns {Object} Wrapped data with timestamp
     */ _wrapCacheData(data) {
        return {
            data: data,
            timestamp: Date.now()
        };
    }
    /**
     * Extracts data from cache wrapper
     * @param {*} cached - Cached value (may be wrapped or raw)
     * @returns {*} Extracted data
     */ _unwrapCacheData(cached) {
        if (cached && typeof cached === 'object' && 'data' in cached && 'timestamp' in cached) return cached.data;
        return cached;
    }
    /**
     * @returns {Object} Default request headers
     */ get headers() {
        return {
            'Content-Type': 'application/json'
        };
    }
    /**
     * Generates a cache key from options object
     * @param {Object} options - Options object
     * @returns {string} Cache key
     */ _getCacheKey(options) {
        const keys = Object.keys(options).sort();
        return keys.map((key)=>`${key}:${options[key]}`).join('|') || 'default';
    }
    /**
     * Clears the cache for packages and/or locations
     * @param {string} type - 'packages', 'locations', or 'all' (default)
     */ clearCache(type = 'all') {
        if (type === 'all' || type === 'packages') this._cache.packages.clear();
        if (type === 'all' || type === 'locations') this._cache.locations = null;
        this._saveCacheToStorage();
    }
    /**
     * Gets available packages (BASE/TOPUP) and top-ups
     * @param {Object} options - Filter options
     * @param {string} options.locationCode - ISO-2 code or !RG (Regional) or !GL (Global)
     * @param {string} options.type - BASE or TOPUP
     * @param {string} options.packageCode - Package code filter
     * @param {string} options.slug - Package slug alias
     * @param {string} options.iccid - ICCID for TOPUP compatibility
     * @returns {Promise<Object>} API response
     */ async packages(options = {}) {
        const cacheKey = this._getCacheKey(options);
        const url = `${this.baseUrl}/package/list`;
        const body = {};
        if (options.locationCode) body.locationCode = options.locationCode;
        if (options.type) body.type = options.type;
        if (options.packageCode) body.packageCode = options.packageCode;
        if (options.slug) body.slug = options.slug;
        if (options.iccid) body.iccid = options.iccid;
        if (this._cache.packages.has(cacheKey)) {
            const cachedValue = this._cache.packages.get(cacheKey);
            const cachedData = this._unwrapCacheData(cachedValue);
            if (!this._pendingRequests.has(cacheKey)) {
                const fetchPromise = fetch(url, {
                    method: 'POST',
                    headers: this.headers,
                    body: Object.keys(body).length > 0 ? JSON.stringify(body) : undefined
                }).then((res)=>{
                    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                    return res.json();
                }).then((data)=>{
                    this._cache.packages.set(cacheKey, this._wrapCacheData(data));
                    this._saveCacheToStorage();
                    this._pendingRequests.delete(cacheKey);
                }).catch((error)=>{
                    console.error('Error updating packages cache:', error);
                    this._pendingRequests.delete(cacheKey);
                });
                this._pendingRequests.set(cacheKey, fetchPromise);
            }
            return cachedData;
        }
        if (this._pendingRequests.has(cacheKey)) {
            await this._pendingRequests.get(cacheKey);
            const cachedValue = this._cache.packages.get(cacheKey);
            if (cachedValue) return this._unwrapCacheData(cachedValue);
        }
        const fetchPromise = fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: Object.keys(body).length > 0 ? JSON.stringify(body) : undefined
        }).then((res)=>{
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
        });
        this._pendingRequests.set(cacheKey, fetchPromise);
        const data = await fetchPromise;
        this._cache.packages.set(cacheKey, this._wrapCacheData(data));
        this._saveCacheToStorage();
        this._pendingRequests.delete(cacheKey);
        return data;
    }
    /**
     * Gets all packages with favorite = true
     * @returns {Promise<Object>} API response with filtered package list containing only favorites
     */ async favorites() {
        const allPackages = await this.packages({});
        if (!allPackages.success || !allPackages.obj?.packageList) return allPackages;
        const favoritePackages = allPackages.obj.packageList.filter((pkg)=>pkg.favorite === true);
        return {
            ...allPackages,
            obj: {
                ...allPackages.obj,
                packageList: favoritePackages
            }
        };
    }
    /**
     * Gets supported regions/countries and codes
     * @returns {Promise<Object>} API response with location list
     */ async locations() {
        const url = `${this.baseUrl}/location/list`;
        const cacheKey = 'locations';
        if (this._cache.locations !== null) {
            const cachedData = this._unwrapCacheData(this._cache.locations);
            if (!this._pendingRequests.has(cacheKey)) {
                const fetchPromise = fetch(url, {
                    method: 'POST',
                    headers: this.headers
                }).then((res)=>{
                    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                    return res.json();
                }).then((data)=>{
                    this._cache.locations = this._wrapCacheData(data);
                    this._saveCacheToStorage();
                    this._pendingRequests.delete(cacheKey);
                }).catch((error)=>{
                    console.error('Error updating locations cache:', error);
                    this._pendingRequests.delete(cacheKey);
                });
                this._pendingRequests.set(cacheKey, fetchPromise);
            }
            return cachedData;
        }
        if (this._pendingRequests.has(cacheKey)) {
            await this._pendingRequests.get(cacheKey);
            if (this._cache.locations !== null) return this._unwrapCacheData(this._cache.locations);
        }
        const fetchPromise = fetch(url, {
            method: 'POST',
            headers: this.headers
        }).then((res)=>{
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
        });
        this._pendingRequests.set(cacheKey, fetchPromise);
        const data = await fetchPromise;
        this._cache.locations = this._wrapCacheData(data);
        this._saveCacheToStorage();
        this._pendingRequests.delete(cacheKey);
        return data;
    }
    /**
     * Orders eSIM profiles (individual or batch)
     * @param {Object} orderData - Order data
     * @param {string} orderData.transactionId - Unique transaction ID (max 50 chars)
     * @param {Array} orderData.packageInfoList - List of packages to order
     * @param {number} orderData.amount - Total amount (optional, in units *10000)
     * @returns {Promise<Object>} API response
     */ async order(orderData) {
        const url = `${this.baseUrl}/esim/order`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(orderData)
        });
        return res.json();
    }
    /**
     * Queries eSIMs by orderNo, ICCID, or date range
     * @param {Object} queryData - Query parameters
     * @param {string} queryData.orderNo - Order number
     * @param {string} queryData.iccid - Specific ICCID
     * @param {string} queryData.startTime - Start date (ISO format)
     * @param {string} queryData.endTime - End date (ISO format)
     * @param {Object} queryData.pager - Pagination (pageNum, pageSize)
     * @returns {Promise<Object>} API response
     */ async query(queryData) {
        const url = `${this.baseUrl}/esim/query`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(queryData)
        });
        return res.json();
    }
    /**
     * Cancels eSIM profile (not installed) with refund
     * @param {Object} identifier - eSIM identifier
     * @param {string} identifier.iccid - ICCID
     * @param {string} identifier.esimTranNo - Transaction number
     * @returns {Promise<Object>} API response
     */ async cancel(identifier) {
        const url = `${this.baseUrl}/esim/cancel`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(identifier)
        });
        return res.json();
    }
    /**
     * Suspends/pauses eSIM data
     * @param {Object} identifier - eSIM identifier (iccid or esimTranNo)
     * @returns {Promise<Object>} API response
     */ async suspend(identifier) {
        const url = `${this.baseUrl}/esim/suspend`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(identifier)
        });
        return res.json();
    }
    /**
     * Reactivates suspended eSIM data
     * @param {Object} identifier - eSIM identifier (iccid or esimTranNo)
     * @returns {Promise<Object>} API response
     */ async unsuspend(identifier) {
        const url = `${this.baseUrl}/esim/unsuspend`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(identifier)
        });
        return res.json();
    }
    /**
     * Revokes active eSIM profile without refund
     * @param {Object} identifier - eSIM identifier (iccid or esimTranNo)
     * @returns {Promise<Object>} API response
     */ async revoke(identifier) {
        const url = `${this.baseUrl}/esim/revoke`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(identifier)
        });
        return res.json();
    }
    /**
     * Top-ups existing eSIM with compatible package
     * @param {Object} topupData - Top-up data
     * @param {string} topupData.esimTranNo - Transaction number (preferred)
     * @param {string} topupData.packageCode - Top-up package code
     * @param {string} topupData.transactionId - Unique transaction ID
     * @param {string} topupData.amount - Price *10000 (optional, validated if sent)
     * @returns {Promise<Object>} API response
     */ async topup(topupData) {
        const url = `${this.baseUrl}/esim/topup`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(topupData)
        });
        return res.json();
    }
    /**
     * Sends SMS to eSIM (requires installed eSIM with SMS support)
     * @param {Object} smsData - SMS data
     * @param {string} smsData.esimTranNo - Transaction number
     * @param {string} smsData.message - Message text (max 500 chars)
     * @returns {Promise<Object>} API response
     */ async sendsms(smsData) {
        const url = `${this.baseUrl}/esim/sendSms`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(smsData)
        });
        return res.json();
    }
    /**
     * Queries data usage for eSIMs (up to 10, updates every 2-3 hours)
     * @param {Array<string>} esimTranNoList - Array of transaction numbers (max 10)
     * @returns {Promise<Object>} API response
     */ async usage(esimTranNoList) {
        const url = `${this.baseUrl}/esim/usage/query`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify({
                esimTranNoList: esimTranNoList
            })
        });
        return res.json();
    }
}
var $42f96fa8e433dde8$export$2e2bcd8739ae039 = $42f96fa8e433dde8$var$EsimProvider;


var $aaf637cd054e3457$exports = {};
$aaf637cd054e3457$exports = JSON.parse('[{"alpha2":"af","alpha3":"afg","name":"Afganistan"},{"alpha2":"ax","alpha3":"ala","name":"Aland"},{"alpha2":"al","alpha3":"alb","name":"Albania"},{"alpha2":"de","alpha3":"deu","name":"Alemania"},{"alpha2":"ad","alpha3":"and","name":"Andorra"},{"alpha2":"ao","alpha3":"ago","name":"Angola","inactive":true},{"alpha2":"ai","alpha3":"aia","name":"Anguila"},{"alpha2":"aq","alpha3":"ata","name":"Antartida","inactive":true},{"alpha2":"ag","alpha3":"atg","name":"Antigua y Barbuda"},{"alpha2":"sa","alpha3":"sau","name":"Arabia Saudita"},{"alpha2":"dz","alpha3":"dza","name":"Argelia"},{"alpha2":"ar","alpha3":"arg","name":"Argentina"},{"alpha2":"am","alpha3":"arm","name":"Armenia"},{"alpha2":"aw","alpha3":"abw","name":"Aruba","inactive":true},{"alpha2":"au","alpha3":"aus","name":"Australia"},{"alpha2":"at","alpha3":"aut","name":"Austria"},{"alpha2":"az","alpha3":"aze","name":"Azerbaiyan"},{"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"alpha2":"bd","alpha3":"bgd","name":"Banglades"},{"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"alpha2":"bh","alpha3":"bhr","name":"Barein"},{"alpha2":"be","alpha3":"bel","name":"Belgica"},{"alpha2":"bz","alpha3":"blz","name":"Belice"},{"alpha2":"bj","alpha3":"ben","name":"Benin"},{"alpha2":"bm","alpha3":"bmu","name":"Bermudas"},{"alpha2":"by","alpha3":"blr","name":"Bielorrusia"},{"alpha2":"bo","alpha3":"bol","name":"Bolivia"},{"alpha2":"bq","alpha3":"bes","name":"Bonaire San Eustaquio y Saba","inactive":true},{"alpha2":"ba","alpha3":"bih","name":"Bosnia y Herzegovina"},{"alpha2":"bw","alpha3":"bwa","name":"Botsuana"},{"alpha2":"br","alpha3":"bra","name":"Brasil"},{"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},{"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"alpha2":"bi","alpha3":"bdi","name":"Burundi","inactive":true},{"alpha2":"bt","alpha3":"btn","name":"Butan","inactive":true},{"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde","inactive":true},{"alpha2":"kh","alpha3":"khm","name":"Camboya"},{"alpha2":"cm","alpha3":"cmr","name":"Camerun"},{"alpha2":"ca","alpha3":"can","name":"Canada"},{"alpha2":"qa","alpha3":"qat","name":"Catar"},{"alpha2":"td","alpha3":"tcd","name":"Chad"},{"alpha2":"cl","alpha3":"chl","name":"Chile"},{"alpha2":"cn","alpha3":"chn","name":"China"},{"alpha2":"cy","alpha3":"cyp","name":"Chipre"},{"alpha2":"co","alpha3":"col","name":"Colombia"},{"alpha2":"km","alpha3":"com","name":"Comoras","inactive":true},{"alpha2":"kp","alpha3":"prk","name":"Corea del Norte","inactive":true},{"alpha2":"kr","alpha3":"kor","name":"Corea del Sur"},{"alpha2":"ci","alpha3":"civ","name":"Costa de Marfil"},{"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"alpha2":"hr","alpha3":"hrv","name":"Croacia"},{"alpha2":"cu","alpha3":"cub","name":"Cuba","inactive":true},{"alpha2":"cw","alpha3":"cuw","name":"Curazao","inactive":true},{"alpha2":"dk","alpha3":"dnk","name":"Dinamarca"},{"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"alpha2":"eg","alpha3":"egy","name":"Egipto"},{"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"alpha2":"ae","alpha3":"are","name":"Emiratos Arabes Unidos"},{"alpha2":"er","alpha3":"eri","name":"Eritrea","inactive":true},{"alpha2":"sk","alpha3":"svk","name":"Eslovaquia"},{"alpha2":"si","alpha3":"svn","name":"Eslovenia"},{"alpha2":"es","alpha3":"esp","name":"Espa\xf1a"},{"alpha2":"us","alpha3":"usa","name":"Estados Unidos"},{"alpha2":"ee","alpha3":"est","name":"Estonia"},{"alpha2":"et","alpha3":"eth","name":"Etiopia","inactive":true},{"alpha2":"ph","alpha3":"phl","name":"Filipinas"},{"alpha2":"fi","alpha3":"fin","name":"Finlandia"},{"alpha2":"fj","alpha3":"fji","name":"Fiyi"},{"alpha2":"fr","alpha3":"fra","name":"Francia"},{"alpha2":"ga","alpha3":"gab","name":"Gabon"},{"alpha2":"gm","alpha3":"gmb","name":"Gambia","inactive":true},{"alpha2":"ge","alpha3":"geo","name":"Georgia"},{"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"alpha2":"gd","alpha3":"grd","name":"Granada"},{"alpha2":"gr","alpha3":"grc","name":"Grecia"},{"alpha2":"gl","alpha3":"grl","name":"Groenlandia","inactive":true},{"alpha2":"gp","alpha3":"glp","name":"Guadalupe"},{"alpha2":"gu","alpha3":"gum","name":"Guam"},{"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"alpha2":"gf","alpha3":"guf","name":"Guayana Francesa","inactive":true},{"alpha2":"gg","alpha3":"ggy","name":"Guernsey"},{"alpha2":"gn","alpha3":"gin","name":"Guinea","inactive":true},{"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bisau","inactive":true},{"alpha2":"gq","alpha3":"gnq","name":"Guinea Ecuatorial","inactive":true},{"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"alpha2":"ht","alpha3":"hti","name":"Haiti","inactive":true},{"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"alpha2":"hk","alpha3":"hkg","name":"Hong Kong"},{"alpha2":"hu","alpha3":"hun","name":"Hungria"},{"alpha2":"in","alpha3":"ind","name":"India"},{"alpha2":"id","alpha3":"idn","name":"Indonesia"},{"alpha2":"iq","alpha3":"irq","name":"Irak"},{"alpha2":"ir","alpha3":"irn","name":"Iran","inactive":true},{"alpha2":"ie","alpha3":"irl","name":"Irlanda"},{"alpha2":"bv","alpha3":"bvt","name":"Isla Bouvet","inactive":true},{"alpha2":"im","alpha3":"imn","name":"Isla de Man"},{"alpha2":"cx","alpha3":"cxr","name":"Isla de Navidad","inactive":true},{"alpha2":"is","alpha3":"isl","name":"Islandia"},{"alpha2":"ky","alpha3":"cym","name":"Islas Caiman"},{"alpha2":"cc","alpha3":"cck","name":"Islas Cocos","inactive":true},{"alpha2":"ck","alpha3":"cok","name":"Islas Cook","inactive":true},{"alpha2":"fo","alpha3":"fro","name":"Islas Feroe"},{"alpha2":"gs","alpha3":"sgs","name":"Islas Georgias del Sur y Sandwich del Sur","inactive":true},{"alpha2":"hm","alpha3":"hmd","name":"Islas Heard y McDonald","inactive":true},{"alpha2":"fk","alpha3":"flk","name":"Islas Malvinas","inactive":true},{"alpha2":"mp","alpha3":"mnp","name":"Islas Marianas del Norte","inactive":true},{"alpha2":"mh","alpha3":"mhl","name":"Islas Marshall","inactive":true},{"alpha2":"pn","alpha3":"pcn","name":"Islas Pitcairn","inactive":true},{"alpha2":"sb","alpha3":"slb","name":"Islas Salomon","inactive":true},{"alpha2":"tc","alpha3":"tca","name":"Islas Turcas y Caicos"},{"alpha2":"um","alpha3":"umi","name":"Islas Ultramarinas Menores de los Estados Unidos","inactive":true},{"alpha2":"vg","alpha3":"vgb","name":"Islas Virgenes Britanicas"},{"alpha2":"vi","alpha3":"vir","name":"Islas Virgenes de los Estados Unidos","inactive":true},{"alpha2":"il","alpha3":"isr","name":"Israel"},{"alpha2":"it","alpha3":"ita","name":"Italia"},{"alpha2":"jm","alpha3":"jam","name":"Jamaica"},{"alpha2":"jp","alpha3":"jpn","name":"Japon"},{"alpha2":"je","alpha3":"jey","name":"Jersey"},{"alpha2":"jo","alpha3":"jor","name":"Jordania"},{"alpha2":"kz","alpha3":"kaz","name":"Kazajistan"},{"alpha2":"ke","alpha3":"ken","name":"Kenia"},{"alpha2":"kg","alpha3":"kgz","name":"Kirguistan"},{"alpha2":"ki","alpha3":"kir","name":"Kiribati","inactive":true},{"alpha2":"xk","alpha3":"xkk","name":"Kosovo"},{"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"alpha2":"la","alpha3":"lao","name":"Laos"},{"alpha2":"ls","alpha3":"lso","name":"Lesoto","inactive":true},{"alpha2":"lv","alpha3":"lva","name":"Letonia"},{"alpha2":"lb","alpha3":"lbn","name":"Libano","inactive":true},{"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"alpha2":"ly","alpha3":"lby","name":"Libia","inactive":true},{"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"alpha2":"lt","alpha3":"ltu","name":"Lituania"},{"alpha2":"lu","alpha3":"lux","name":"Luxemburgo"},{"alpha2":"mo","alpha3":"mac","name":"Macao"},{"alpha2":"mk","alpha3":"mkd","name":"Macedonia del Norte"},{"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},{"alpha2":"my","alpha3":"mys","name":"Malasia"},{"alpha2":"mw","alpha3":"mwi","name":"Malaui"},{"alpha2":"mv","alpha3":"mdv","name":"Maldivas"},{"alpha2":"ml","alpha3":"mli","name":"Mali"},{"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"alpha2":"ma","alpha3":"mar","name":"Marruecos"},{"alpha2":"mq","alpha3":"mtq","name":"Martinica","inactive":true},{"alpha2":"mu","alpha3":"mus","name":"Mauricio"},{"alpha2":"mr","alpha3":"mrt","name":"Mauritania","inactive":true},{"alpha2":"yt","alpha3":"myt","name":"Mayotte","inactive":true},{"alpha2":"mx","alpha3":"mex","name":"Mexico"},{"alpha2":"fm","alpha3":"fsm","name":"Micronesia","inactive":true},{"alpha2":"md","alpha3":"mda","name":"Moldavia"},{"alpha2":"mc","alpha3":"mco","name":"Monaco","inactive":true},{"alpha2":"mn","alpha3":"mng","name":"Mongolia"},{"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"alpha2":"ms","alpha3":"msr","name":"Montserrat","inactive":true},{"alpha2":"mz","alpha3":"moz","name":"Mozambique"},{"alpha2":"mm","alpha3":"mmr","name":"Birmania","inactive":true},{"alpha2":"na","alpha3":"nam","name":"Namibia","inactive":true},{"alpha2":"nr","alpha3":"nru","name":"Nauru","inactive":true},{"alpha2":"np","alpha3":"npl","name":"Nepal"},{"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"alpha2":"ne","alpha3":"ner","name":"Niger"},{"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"alpha2":"nu","alpha3":"niu","name":"Niue","inactive":true},{"alpha2":"nf","alpha3":"nfk","name":"Isla Norfolk","inactive":true},{"alpha2":"no","alpha3":"nor","name":"Noruega"},{"alpha2":"nc","alpha3":"ncl","name":"Nueva Caledonia","inactive":true},{"alpha2":"nz","alpha3":"nzl","name":"Nueva Zelanda"},{"alpha2":"om","alpha3":"omn","name":"Oman"},{"alpha2":"nl","alpha3":"nld","name":"Paises Bajos"},{"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"alpha2":"pw","alpha3":"plw","name":"Palaos","inactive":true},{"alpha2":"ps","alpha3":"pse","name":"Palestina","inactive":true},{"alpha2":"pa","alpha3":"pan","name":"Panama"},{"alpha2":"pg","alpha3":"png","name":"Papua Nueva Guinea","inactive":true},{"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"alpha2":"pe","alpha3":"per","name":"Peru"},{"alpha2":"pf","alpha3":"pyf","name":"Polinesia Francesa","inactive":true},{"alpha2":"pl","alpha3":"pol","name":"Polonia"},{"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},{"alpha2":"gb","alpha3":"gbr","name":"Reino Unido"},{"alpha2":"eh","alpha3":"esh","name":"Republica Arabe Saharaui Democratica","inactive":true},{"alpha2":"cf","alpha3":"caf","name":"Republica Centroafricana"},{"alpha2":"cz","alpha3":"cze","name":"Republica Checa"},{"alpha2":"cg","alpha3":"cog","name":"Republica del Congo"},{"alpha2":"cd","alpha3":"cod","name":"Republica Democratica del Congo","inactive":true},{"alpha2":"do","alpha3":"dom","name":"Republica Dominicana"},{"alpha2":"re","alpha3":"reu","name":"Reunion"},{"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},{"alpha2":"ro","alpha3":"rou","name":"Rumania"},{"alpha2":"ru","alpha3":"rus","name":"Rusia","inactive":true},{"alpha2":"ws","alpha3":"wsm","name":"Samoa","inactive":true},{"alpha2":"as","alpha3":"asm","name":"Samoa Americana","inactive":true},{"alpha2":"bl","alpha3":"blm","name":"San Bartolome","inactive":true},{"alpha2":"kn","alpha3":"kna","name":"San Cristobal y Nieves"},{"alpha2":"sm","alpha3":"smr","name":"San Marino","inactive":true},{"alpha2":"mf","alpha3":"maf","name":"San Martin","inactive":true},{"alpha2":"pm","alpha3":"spm","name":"San Pedro y Miquelon","inactive":true},{"alpha2":"vc","alpha3":"vct","name":"San Vicente y las Granadinas"},{"alpha2":"sh","alpha3":"shn","name":"Santa Elena Ascension y Tristan de Acu\xf1a","inactive":true},{"alpha2":"lc","alpha3":"lca","name":"Santa Lucia"},{"alpha2":"st","alpha3":"stp","name":"Santo Tome y Principe","inactive":true},{"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"alpha2":"rs","alpha3":"srb","name":"Serbia"},{"alpha2":"sc","alpha3":"syc","name":"Seychelles"},{"alpha2":"sl","alpha3":"sle","name":"Sierra Leona","inactive":true},{"alpha2":"sg","alpha3":"sgp","name":"Singapur"},{"alpha2":"sx","alpha3":"sxm","name":"San Martin","inactive":true},{"alpha2":"sy","alpha3":"syr","name":"Siria","inactive":true},{"alpha2":"so","alpha3":"som","name":"Somalia","inactive":true},{"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"alpha2":"sz","alpha3":"swz","name":"Suazilandia"},{"alpha2":"za","alpha3":"zaf","name":"Sudafrica"},{"alpha2":"sd","alpha3":"sdn","name":"Sudan"},{"alpha2":"ss","alpha3":"ssd","name":"Sudan del Sur","inactive":true},{"alpha2":"se","alpha3":"swe","name":"Suecia"},{"alpha2":"ch","alpha3":"che","name":"Suiza"},{"alpha2":"sr","alpha3":"sur","name":"Surinam"},{"alpha2":"sj","alpha3":"sjm","name":"Svalbard y Jan Mayen","inactive":true},{"alpha2":"th","alpha3":"tha","name":"Tailandia"},{"alpha2":"tw","alpha3":"twn","name":"Taiwan Republica de China","inactive":true},{"alpha2":"tz","alpha3":"tza","name":"Tanzania"},{"alpha2":"tj","alpha3":"tjk","name":"Tayikistan"},{"alpha2":"io","alpha3":"iot","name":"Territorio Britanico del Oceano Indico","inactive":true},{"alpha2":"tf","alpha3":"atf","name":"Tierras Australes y Antarticas Francesas","inactive":true},{"alpha2":"tl","alpha3":"tls","name":"Timor Oriental","inactive":true},{"alpha2":"tg","alpha3":"tgo","name":"Togo","inactive":true},{"alpha2":"tk","alpha3":"tkl","name":"Tokelau","inactive":true},{"alpha2":"to","alpha3":"ton","name":"Tonga","inactive":true},{"alpha2":"tt","alpha3":"tto","name":"Trinidad y Tobago"},{"alpha2":"tn","alpha3":"tun","name":"Tunez"},{"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan","inactive":true},{"alpha2":"tr","alpha3":"tur","name":"Turquia"},{"alpha2":"tv","alpha3":"tuv","name":"Tuvalu","inactive":true},{"alpha2":"ua","alpha3":"ukr","name":"Ucrania"},{"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},{"alpha2":"vu","alpha3":"vut","name":"Vanuatu","inactive":true},{"alpha2":"va","alpha3":"vat","name":"Vaticano Ciudad del","inactive":true},{"alpha2":"ve","alpha3":"ven","name":"Venezuela","inactive":true},{"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},{"alpha2":"wf","alpha3":"wlf","name":"Wallis y Futuna","inactive":true},{"alpha2":"ye","alpha3":"yem","name":"Yemen","inactive":true},{"alpha2":"dj","alpha3":"dji","name":"Yibuti","inactive":true},{"alpha2":"zm","alpha3":"zmb","name":"Zambia"},{"alpha2":"zw","alpha3":"zwe","name":"Zimbabue","inactive":true}]');



var $7xovm = parcelRequire("7xovm");
class $c7b3ccf621005a3a$var$Cart {
    /**
     * @param {string} storageKey - LocalStorage key for cart persistence
     */ constructor(storageKey = 'cart'){
        this.cart = [];
        this.STORAGE_KEY = storageKey;
        this.loadCartFromStorage();
    }
    /**
     * Saves cart to localStorage
     */ saveCartToStorage() {
        try {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.cart));
        } catch (error) {
            console.warn('Failed to save cart to localStorage:', error);
        }
    }
    /**
     * Loads cart from localStorage
     */ loadCartFromStorage() {
        try {
            const storedCart = localStorage.getItem(this.STORAGE_KEY);
            if (storedCart) {
                this.cart = JSON.parse(storedCart);
                if (!Array.isArray(this.cart)) this.cart = [];
            }
        } catch (error) {
            console.warn('Failed to load cart from localStorage:', error);
            this.cart = [];
        }
    }
    /**
     * Clears cart from localStorage
     */ clearCartStorage() {
        try {
            localStorage.removeItem(this.STORAGE_KEY);
        } catch (error) {
            console.warn('Failed to clear cart from localStorage:', error);
        }
    }
    /**
     * Adds item to cart or increments quantity if exists
     * @param {Object} item - Item to add
     * @param {string} identifierKey - Key to identify items (default: 'id')
     * @returns {Array} Updated cart array
     */ addToCart(item, identifierKey = 'id') {
        const existingIndex = this.cart.findIndex((cartItem)=>cartItem[identifierKey] === item[identifierKey]);
        if (existingIndex >= 0) this.cart[existingIndex].quantity += 1;
        else this.cart.push({
            ...item,
            quantity: 1
        });
        this.saveCartToStorage();
        return this.cart;
    }
    /**
     * Removes item from cart by identifier
     * @param {string|number} identifier - Value to match against identifierKey
     * @param {string} identifierKey - Key to identify items (default: 'id')
     * @returns {Array} Updated cart array
     */ removeFromCart(identifier, identifierKey = 'id') {
        this.cart = this.cart.filter((item)=>item[identifierKey] !== identifier);
        this.saveCartToStorage();
        return this.cart;
    }
    /**
     * Updates quantity of item in cart
     * @param {string|number} identifier - Value to match against identifierKey
     * @param {number} quantity - New quantity (removes if <= 0)
     * @param {string} identifierKey - Key to identify items (default: 'id')
     * @returns {Array} Updated cart array
     */ updateCartQuantity(identifier, quantity, identifierKey = 'id') {
        const item = this.cart.find((item)=>item[identifierKey] === identifier);
        if (item) {
            if (quantity <= 0) return this.removeFromCart(identifier, identifierKey);
            item.quantity = quantity;
        }
        this.saveCartToStorage();
        return this.cart;
    }
    /**
     * @returns {Array} Current cart items
     */ getCart() {
        return this.cart;
    }
    /**
     * Calculates total cart value
     * @param {string} priceKey - Property name for price (default: 'price')
     * @returns {number} Total cart value
     */ getCartTotal(priceKey = 'price') {
        return this.cart.reduce((total, item)=>{
            return total + parseFloat(item[priceKey]) * item.quantity;
        }, 0);
    }
    /**
     * Clears all items from cart
     * @returns {Array} Empty cart array
     */ clearCart() {
        this.cart = [];
        this.clearCartStorage();
        return this.cart;
    }
    /**
     * @returns {number} Total quantity of all items in cart
     */ getTotalItems() {
        return this.cart.reduce((sum, item)=>sum + item.quantity, 0);
    }
}
var $c7b3ccf621005a3a$export$2e2bcd8739ae039 = $c7b3ccf621005a3a$var$Cart;



var $gGcib = parcelRequire("gGcib");
class $720883cc9bd4d85c$var$EsimStore {
    constructor(provider){
        this.provider = provider;
        this.allLocations = [];
        this.countriesFromJson = []; // Countries from countries.json for Spanish language
        this.allPlans = [];
        this.selectedCountries = [];
        this.currentSelectedLocation = null;
        this.cart = new (0, $c7b3ccf621005a3a$export$2e2bcd8739ae039)('ily-cart');
    }
    /**
     * Loads all locations from API
     */ async loadAllLocations() {
        try {
            const response = await this.provider.locations();
            if (response.success && response.obj.locationList) this.allLocations = response.obj.locationList;
        } catch (error) {
            console.error('Error loading locations:', error);
        }
    }
    /**
     * Loads countries from countries.json file
     */ async loadCountriesFromJson() {
        try {
            this.countriesFromJson = (0, (/*@__PURE__*/$parcel$interopDefault($aaf637cd054e3457$exports))).filter((country)=>!country.inactive);
        } catch (error) {
            console.error('Error loading countries.json:', error);
            this.countriesFromJson = [];
        }
    }
    /**
     * Loads all eSIM plans from API with optional filters
     * @param {Object} options - Filter options
     * @param {Array<number>} options.supportTopUpType - Filter by top-up support (default: [1, 2])
     * @param {Array<number>} options.dataType - Filter by data type (default: [1])
     */ async loadAllPlans(options = {}) {
        try {
            const { supportTopUpType: supportTopUpType = [
                1,
                2
            ], dataType: dataType = [
                1
            ] } = options;
            this.allPlans = [];
            const allPackagesResponse = await this.provider.packages({});
            if (allPackagesResponse.success && allPackagesResponse.obj?.packageList) {
                let plans = allPackagesResponse.obj.packageList;
                const supportTopUpTypeArray = Array.isArray(supportTopUpType) ? supportTopUpType : [
                    supportTopUpType
                ];
                plans = plans.filter((plan)=>{
                    const planTopUpType = plan.supportTopUpType;
                    return supportTopUpTypeArray.includes(planTopUpType);
                });
                const dataTypeArray = Array.isArray(dataType) ? dataType : [
                    dataType
                ];
                plans = plans.filter((plan)=>{
                    const planDataType = plan.dataType;
                    return dataTypeArray.includes(planDataType);
                });
                this.allPlans = plans;
            }
        } catch (error) {
            console.error('Error loading plans:', error);
        }
    }
    /**
     * Gets location name by code, prioritizing countries.json for Spanish
     * @param {string} locationCode - ISO-2 location code
     * @returns {string} Location name or code if not found
     */ getLocationName(locationCode) {
        if (!locationCode) return locationCode || 'Unknown';
        const isSpanish = (0, $7xovm.default).getLanguage() === 'es';
        if (isSpanish && this.countriesFromJson.length > 0) {
            const locationCodeLower = locationCode.toLowerCase();
            const country = this.countriesFromJson.find((c)=>c.alpha2.toLowerCase() === locationCodeLower);
            if (country) return country.name;
        }
        if (this.allLocations.length > 0) {
            const location = this.allLocations.find((loc)=>loc.code === locationCode);
            if (location) return location.name;
        }
        return locationCode;
    }
    /**
     * Generates flag icon HTML for location code
     * @param {string} locationCode - ISO-2 location code
     * @returns {string} HTML string with flag icon
     */ getFlagIcon(locationCode) {
        const code = locationCode || 'xx';
        let codeLower = code.toLowerCase();
        if (codeLower.startsWith('eu')) codeLower = 'eu';
        if (codeLower.startsWith('gl')) codeLower = 'un';
        return `<span class="fi fi-${codeLower} rounded-1"></span>`;
    }
    /**
     * Searches locations by name or code
     * @param {string} query - Search query
     * @param {boolean} useCountriesJson - Use countries.json instead of API (default: false)
     * @returns {Array<Object>} Array of matching locations (max 10)
     */ searchLocations(query, useCountriesJson = false) {
        if (!query || query.length < 1) return [];
        const normalizedQuery = (0, $gGcib.normalizeText)(query);
        const queryParts = normalizedQuery.split(' ').filter((part)=>part.length > 0);
        if (useCountriesJson && this.countriesFromJson.length > 0) return this.countriesFromJson.map((country)=>({
                name: country.name,
                code: country.alpha2.toUpperCase(),
                type: 1 // All countries from JSON are type 1
            })).filter((location)=>{
            const normalizedName = (0, $gGcib.normalizeText)(location.name);
            const normalizedCode = (0, $gGcib.normalizeText)(location.code);
            if (normalizedCode === normalizedQuery) return true;
            const nameMatches = queryParts.every((part)=>normalizedName.includes(part) || normalizedCode.includes(part));
            return nameMatches;
        }).sort((a, b)=>{
            const aCodeMatch = (0, $gGcib.normalizeText)(a.code) === normalizedQuery;
            const bCodeMatch = (0, $gGcib.normalizeText)(b.code) === normalizedQuery;
            if (aCodeMatch && !bCodeMatch) return -1;
            if (!aCodeMatch && bCodeMatch) return 1;
            const aStartsWith = (0, $gGcib.normalizeText)(a.name).startsWith(normalizedQuery);
            const bStartsWith = (0, $gGcib.normalizeText)(b.name).startsWith(normalizedQuery);
            if (aStartsWith && !bStartsWith) return -1;
            if (!aStartsWith && bStartsWith) return 1;
            return a.name.localeCompare(b.name);
        }).slice(0, 10);
        return this.allLocations.filter((location)=>{
            const normalizedName = (0, $gGcib.normalizeText)(location.name);
            const normalizedCode = (0, $gGcib.normalizeText)(location.code);
            if (normalizedCode === normalizedQuery) return true;
            const nameMatches = queryParts.every((part)=>normalizedName.includes(part) || normalizedCode.includes(part));
            return nameMatches;
        }).sort((a, b)=>{
            const aCodeMatch = (0, $gGcib.normalizeText)(a.code) === normalizedQuery;
            const bCodeMatch = (0, $gGcib.normalizeText)(b.code) === normalizedQuery;
            if (aCodeMatch && !bCodeMatch) return -1;
            if (!aCodeMatch && bCodeMatch) return 1;
            const aStartsWith = (0, $gGcib.normalizeText)(a.name).startsWith(normalizedQuery);
            const bStartsWith = (0, $gGcib.normalizeText)(b.name).startsWith(normalizedQuery);
            if (aStartsWith && !bStartsWith) return -1;
            if (!aStartsWith && bStartsWith) return 1;
            if (a.type !== b.type) return a.type - b.type;
            return a.name.localeCompare(b.name);
        }).slice(0, 10);
    }
    /**
     * Adds country to selected countries list
     * @param {Object} location - Location object with code and name
     * @returns {boolean} True if added, false if already exists
     */ addCountry(location) {
        if (this.selectedCountries.find((c)=>c.code === location.code)) return false; // Already added
        this.selectedCountries.push(location);
        return true;
    }
    /**
     * Removes country from selected countries list
     * @param {string} locationCode - Location code to remove
     */ removeCountry(locationCode) {
        this.selectedCountries = this.selectedCountries.filter((c)=>c.code !== locationCode);
    }
    /**
     * @returns {Array<Object>} Array of selected countries
     */ getSelectedCountries() {
        return this.selectedCountries;
    }
    /**
     * Sets current selected location for filtering
     * @param {Object} locationData - Location data with plans
     */ setCurrentLocation(locationData) {
        this.currentSelectedLocation = locationData;
    }
    /**
     * @returns {Object|null} Current selected location or null
     */ getCurrentLocation() {
        return this.currentSelectedLocation;
    }
    /**
     * Clears current selected location
     */ clearCurrentLocation() {
        this.currentSelectedLocation = null;
    }
    /**
     * Filters plans by selected countries, includes regional plans for multiple countries
     * @returns {Object|null} Plans grouped by locationCode or null if no matches
     */ filterPlans() {
        if (this.selectedCountries.length === 0) return null;
        const countryCodes = this.selectedCountries.map((c)=>c.code);
        let matchingPlans = this.allPlans.filter((plan)=>{
            const planLocationCode = plan.locationCode || plan.location;
            return countryCodes.includes(planLocationCode);
        });
        if (this.selectedCountries.length > 1) {
            const regionalPlans = this.allPlans.filter((plan)=>{
                if (!plan.locationNetworkList || !Array.isArray(plan.locationNetworkList)) return false;
                const networkListCodes = plan.locationNetworkList.map((loc)=>loc.locationCode || loc.code || loc);
                return countryCodes.every((code)=>networkListCodes.includes(code));
            });
            const existingPlanCodes = new Set(matchingPlans.map((p)=>p.packageCode));
            regionalPlans.forEach((plan)=>{
                if (!existingPlanCodes.has(plan.packageCode)) matchingPlans.push(plan);
            });
        }
        if (matchingPlans.length === 0) return null;
        const plansByLocation = {};
        matchingPlans.forEach((plan)=>{
            const locationCode = plan.locationCode || plan.location || 'UNKNOWN';
            if (!plansByLocation[locationCode]) {
                const locationName = this.getLocationName(locationCode);
                plansByLocation[locationCode] = {
                    locationCode: locationCode,
                    location: locationName,
                    plans: []
                };
            }
            plansByLocation[locationCode].plans.push(plan);
        });
        return plansByLocation;
    }
    /**
     * Adds eSIM package to cart
     * @param {Object} packageData - Package data object
     * @returns {Array} Updated cart array
     */ addToCart(packageData) {
        return this.cart.addToCart(packageData, 'packageCode');
    }
    /**
     * Removes package from cart by packageCode
     * @param {string} packageCode - Package code to remove
     * @returns {Array} Updated cart array
     */ removeFromCart(packageCode) {
        return this.cart.removeFromCart(packageCode, 'packageCode');
    }
    /**
     * Updates quantity of package in cart
     * @param {string} packageCode - Package code
     * @param {number} quantity - New quantity
     * @returns {Array} Updated cart array
     */ updateCartQuantity(packageCode, quantity) {
        return this.cart.updateCartQuantity(packageCode, quantity, 'packageCode');
    }
    /**
     * @returns {Array} Current cart items
     */ getCart() {
        return this.cart.getCart();
    }
    /**
     * @returns {number} Total cart value
     */ getCartTotal() {
        return this.cart.getCartTotal('price');
    }
    /**
     * @returns {Array} Empty cart array
     */ clearCart() {
        return this.cart.clearCart();
    }
    /**
     * Prepares location data for tag rendering
     * @param {Object} location - Location object
     * @returns {Object} Tag data with code, name, and flagIcon
     */ prepareTagData(location) {
        return {
            code: location.code,
            name: location.name,
            flagIcon: this.getFlagIcon(location.code)
        };
    }
    /**
     * Prepares matching plans data for rendering grouped by location
     * @param {Object} plansByLocation - Plans grouped by locationCode
     * @returns {Array<Object>|null} Array of location plan data or null
     */ prepareMatchingPlansData(plansByLocation) {
        if (!plansByLocation) return null;
        const locationKeys = Object.keys(plansByLocation);
        if (locationKeys.length === 0) return null;
        return locationKeys.map((locationCode)=>{
            const locationData = plansByLocation[locationCode];
            const planCount = locationData.plans.length;
            const locationName = locationData.location || this.getLocationName(locationCode);
            const prices = locationData.plans.map((p)=>p.price / 10000);
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            const priceRange = minPrice === maxPrice ? `$${minPrice.toFixed(2)}` : `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
            return {
                locationCode: locationCode,
                locationName: locationName,
                flagIcon: this.getFlagIcon(locationCode),
                planCount: planCount,
                planText: planCount !== 1 ? (0, $7xovm.default).t('plans') : (0, $7xovm.default).t('plan'),
                priceRange: priceRange,
                locationData: locationData // Keep reference to original data
            };
        });
    }
    /**
     * Prepares duration options data from location plans
     * @param {Object} locationData - Location data with plans array
     * @returns {Array<Object>} Array of duration data with price ranges
     */ prepareDurationsData(locationData) {
        if (!locationData || !locationData.plans) return [];
        const durationsMap = {};
        locationData.plans.forEach((plan)=>{
            const durationKey = `${plan.duration} ${plan.durationUnit?.toLowerCase() || 'days'}`;
            if (!durationsMap[durationKey]) durationsMap[durationKey] = {
                duration: plan.duration,
                durationUnit: plan.durationUnit,
                display: durationKey,
                plans: []
            };
            durationsMap[durationKey].plans.push(plan);
        });
        const durations = Object.values(durationsMap).sort((a, b)=>a.duration - b.duration);
        return durations.map((duration)=>{
            const prices = duration.plans.map((p)=>p.price / 10000);
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            const priceRange = minPrice === maxPrice ? `$${minPrice.toFixed(2)}` : `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
            return {
                duration: duration.duration,
                durationUnit: duration.durationUnit,
                display: duration.display,
                priceRange: priceRange,
                packageCount: duration.plans.length,
                packageText: duration.plans.length !== 1 ? (0, $7xovm.default).t('packages') : (0, $7xovm.default).t('package'),
                plans: duration.plans // Keep reference to original plans
            };
        });
    }
    /**
     * Prepares package data grouped by volume for specific duration
     * @param {number} duration - Duration value
     * @param {string} unit - Duration unit (days, months, etc.)
     * @returns {Array<Object>} Array of package data grouped by volume
     */ preparePackagesData(duration, unit) {
        const currentLocation = this.getCurrentLocation();
        if (!currentLocation) return [];
        const filteredPlans = currentLocation.plans.filter((plan)=>plan.duration === duration && plan.durationUnit === unit);
        const volumesMap = {};
        filteredPlans.forEach((plan)=>{
            const displayVolume = (0, $gGcib.formatVolume)(plan.volume);
            if (!volumesMap[displayVolume]) volumesMap[displayVolume] = [];
            volumesMap[displayVolume].push(plan);
        });
        const volumes = Object.keys(volumesMap).sort((a, b)=>{
            const aBytes = a.includes('GB') ? parseFloat(a) * 1024 : parseFloat(a);
            const bBytes = b.includes('GB') ? parseFloat(b) * 1024 : parseFloat(b);
            return aBytes - bBytes;
        });
        return volumes.map((volume)=>{
            const volumePlans = volumesMap[volume];
            const prices = volumePlans.map((p)=>p.price / 10000);
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            const priceRange = minPrice === maxPrice ? `$${minPrice.toFixed(2)}` : `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
            const representativePlan = volumePlans[0];
            return {
                volume: volume,
                priceRange: priceRange,
                name: representativePlan.name || representativePlan.packageCode,
                plans: volumePlans // Keep reference to original plans
            };
        });
    }
    /**
     * Prepares detailed package data for rendering
     * @param {Array<Object>} plans - Array of plan objects
     * @returns {Array<Object>} Array of formatted package details
     */ preparePackageDetailsData(plans) {
        return plans.map((plan)=>{
            const price = (plan.price / 10000).toFixed(2);
            const displayVolume = (0, $gGcib.formatVolume)(plan.volume);
            let operatorListDisplay = '';
            if (plan.operatorList && Array.isArray(plan.operatorList)) operatorListDisplay = plan.operatorList.join(', ');
            else if (plan.operatorList) operatorListDisplay = plan.operatorList;
            let supportTopUpTypeDisplay = null;
            if (plan.supportTopUpType === 1) supportTopUpTypeDisplay = (0, $7xovm.default).t('no');
            else if (plan.supportTopUpType === 2) supportTopUpTypeDisplay = (0, $7xovm.default).t('yes');
            let activeTypeDisplay = null;
            if (plan.activeType === 1) activeTypeDisplay = (0, $7xovm.default).t('firstInstallation');
            else if (plan.activeType === 2) activeTypeDisplay = (0, $7xovm.default).t('firstNetworkConnection');
            let dataTypeDisplay = null;
            if (plan.dataType === 1) dataTypeDisplay = (0, $7xovm.default).t('dataInTotal');
            else if (plan.dataType === 2) dataTypeDisplay = (0, $7xovm.default).t('dailyLimitSpeedReduced');
            else if (plan.dataType === 3) dataTypeDisplay = (0, $7xovm.default).t('dailyLimitServiceCutoff');
            else if (plan.dataType === 4) dataTypeDisplay = (0, $7xovm.default).t('dailyUnlimited');
            const locationCode = plan.locationCode || plan.location;
            const locationName = this.getLocationName(locationCode) || locationCode;
            let countriesList = [];
            if (plan.locationNetworkList && Array.isArray(plan.locationNetworkList)) countriesList = plan.locationNetworkList.map((loc)=>{
                const code = loc.locationCode || loc.code || loc;
                const name = this.getLocationName(code) || code;
                return {
                    code: code,
                    name: name,
                    flagIcon: this.getFlagIcon(code)
                };
            });
            const charge = plan.charge ? (plan.charge / 10000).toFixed(2) : 0;
            return {
                name: plan.name || plan.packageCode,
                packageCode: plan.packageCode,
                price: price,
                charge: charge,
                displayVolume: displayVolume,
                duration: plan.duration,
                durationUnit: plan.durationUnit?.toLowerCase() || (0, $7xovm.default).t('days'),
                hasSpeed: !!plan.speed,
                speed: plan.speed || '',
                smsStatus: plan.smsStatus ? (0, $7xovm.default).t('included') : (0, $7xovm.default).t('notIncluded'),
                dataType: dataTypeDisplay,
                activeType: activeTypeDisplay,
                operatorList: operatorListDisplay || null,
                supportTopUpType: supportTopUpTypeDisplay,
                locationCode: locationCode,
                locationName: locationName,
                hasCountries: countriesList.length > 0,
                countries: countriesList
            };
        });
    }
}
var $720883cc9bd4d85c$export$2e2bcd8739ae039 = $720883cc9bd4d85c$var$EsimStore;



var $7xovm = parcelRequire("7xovm");

class $e1fc32ee47c23d00$var$Account {
    constructor(){
        this.currentUser = null;
        this.token = null;
        this.USER_STORAGE_KEY = 'ily-user';
        this.TOKEN_STORAGE_KEY = 'ily-token';
        this.loadUserFromStorage();
    }
    /**
     * Saves user and token to localStorage
     * @param {Object} user - User object
     * @param {string} token - Authentication token
     */ saveUserToStorage(user, token) {
        try {
            if (user && token) {
                localStorage.setItem(this.USER_STORAGE_KEY, JSON.stringify(user));
                localStorage.setItem(this.TOKEN_STORAGE_KEY, token);
                this.currentUser = user;
                this.token = token;
            }
        } catch (error) {
            console.warn('Failed to save user to localStorage:', error);
        }
    }
    /**
     * Loads user and token from localStorage
     */ loadUserFromStorage() {
        try {
            const storedUser = localStorage.getItem(this.USER_STORAGE_KEY);
            const storedToken = localStorage.getItem(this.TOKEN_STORAGE_KEY);
            if (storedUser && storedToken) {
                this.currentUser = JSON.parse(storedUser);
                this.token = storedToken;
            }
        } catch (error) {
            console.warn('Failed to load user from localStorage:', error);
            this.currentUser = null;
            this.token = null;
        }
    }
    /**
     * Clears user and token from localStorage
     */ clearUserStorage() {
        try {
            localStorage.removeItem(this.USER_STORAGE_KEY);
            localStorage.removeItem(this.TOKEN_STORAGE_KEY);
            this.currentUser = null;
            this.token = null;
        } catch (error) {
            console.warn('Failed to clear user from localStorage:', error);
        }
    }
    /**
     * Decodes JWT payload (no signature verification; used only to build minimal user from token).
     * @param {string} token - JWT token
     * @returns {Object|null} Decoded payload or null
     */ _decodeJwtPayload(token) {
        try {
            const parts = token.split('.');
            if (parts.length !== 3) return null;
            const payload = parts[1];
            const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
            const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
            const json = atob(padded);
            return JSON.parse(json);
        } catch (e) {
            return null;
        }
    }
    /**
     * Logs in using a token from URL (e.g. link from admin). Saves token and builds minimal user from JWT payload.
     * Same token format as POST /api/auth/verify-code; use as Bearer in API requests.
     * @param {string} token - JWT token from query string
     * @returns {boolean} True if token was valid and session was set
     */ loginWithToken(token) {
        if (!token || typeof token !== 'string') return false;
        const payload = this._decodeJwtPayload(token.trim());
        if (!payload) return false;
        const userId = payload.userId ?? payload.sub ?? payload.id;
        if (!userId) return false;
        const user = {
            id: userId,
            email: payload.email ?? '',
            name: payload.name ?? null,
            lastname: payload.lastname ?? null,
            language: payload.language ?? null,
            emailVerified: payload.emailVerified ?? false
        };
        this.saveUserToStorage(user, token.trim());
        return true;
    }
    /**
     * Sends verification code to email (for registration or login)
     * @param {string} email - User email
     * @param {string} name - User full name (optional, for registration)
     * @returns {Promise<Object>} Send code response
     */ async sendVerificationCode(email, name = null) {
        try {
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.auth;
            const language = (0, $7xovm.default).getLanguage();
            const response = await fetch(`${baseUrl}/request-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    name: name,
                    language: language
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to send verification code');
            return data;
        } catch (error) {
            console.error('Send verification code error:', error);
            throw error;
        }
    }
    /**
     * Verifies code and logs in/registers user
     * @param {string} email - User email
     * @param {string} code - Verification code
     * @returns {Promise<Object>} Verification response with user and token
     */ async verifyCode(email, code) {
        try {
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.auth;
            const response = await fetch(`${baseUrl}/verify-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    code: code
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Code verification failed');
            if (data.user && data.token) this.saveUserToStorage(data.user, data.token);
            return data;
        } catch (error) {
            console.error('Code verification error:', error);
            throw error;
        }
    }
    /**
     * Requests verification code for checkout
     * @param {string} email - User email
     * @returns {Promise<Object>} Request code response
     */ async requestCode(email) {
        try {
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.auth;
            const language = (0, $7xovm.default).getLanguage();
            const response = await fetch(`${baseUrl}/request-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    language: language
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to request verification code');
            return data;
        } catch (error) {
            console.error('Request code error:', error);
            throw error;
        }
    }
    /**
     * Verifies code for checkout and returns user data with token
     * @param {string} email - User email
     * @param {string} code - Verification code
     * @returns {Promise<Object>} Verification response with user and token
     */ async verifyCodeForCheckout(email, code) {
        try {
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.auth;
            const response = await fetch(`${baseUrl}/verify-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    code: code
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Code verification failed');
            // Save user and token for checkout
            if (data.user && data.token) this.saveUserToStorage(data.user, data.token);
            return data;
        } catch (error) {
            console.error('Code verification for checkout error:', error);
            throw error;
        }
    }
    /**
     * Logs out user and reloads page
     */ async logout() {
        this.clearUserStorage();
        window.location.reload();
    }
    /**
     * Verifies user email with token
     * @param {string} token - Email verification token
     * @returns {Promise<Object>} Verification response
     */ async verifyEmail(token) {
        try {
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.auth;
            const response = await fetch(`${baseUrl}/verify-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: token
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Email verification failed');
            if (this.currentUser && data.user) {
                this.currentUser = data.user;
                this.saveUserToStorage(this.currentUser, this.token);
            }
            return data;
        } catch (error) {
            console.error('Email verification error:', error);
            throw error;
        }
    }
    /**
     * @returns {boolean} True if user is authenticated
     */ isAuthenticated() {
        return !!this.currentUser && !!this.token;
    }
    /**
     * @returns {Object|null} Current user object or null
     */ getCurrentUser() {
        return this.currentUser;
    }
    /**
     * @returns {string|null} Authentication token or null
     */ getToken() {
        return this.token;
    }
    /**
     * @returns {boolean} True if user email is verified
     */ isEmailVerified() {
        return this.currentUser?.emailVerified || false;
    }
    /**
     * Resends verification email to user
     * @returns {Promise<Object>} Resend response
     */ async resendVerificationEmail() {
        try {
            if (!this.currentUser || !this.currentUser.id) throw new Error('User not authenticated');
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.auth;
            const language = (0, $7xovm.default).getLanguage();
            const response = await fetch(`${baseUrl}/resend-verification-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.token}`
                },
                body: JSON.stringify({
                    userId: this.currentUser.id,
                    language: language
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to resend verification email');
            return data;
        } catch (error) {
            console.error('Resend verification email error:', error);
            throw error;
        }
    }
    /**
     * Updates user profile information
     * @param {string} userId - User ID
     * @param {Object} profileData - Profile data (name, lastname, language)
     * @returns {Promise<Object>} Update response
     */ async updateProfile(userId, profileData) {
        try {
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.baseUrl;
            const response = await fetch(`${baseUrl}/user/${userId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.token}`
                },
                body: JSON.stringify(profileData)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Profile update failed');
            if (data.user) {
                this.currentUser = data.user;
                this.saveUserToStorage(this.currentUser, this.token);
            }
            return data;
        } catch (error) {
            console.error('Profile update error:', error);
            throw error;
        }
    }
}
var $e1fc32ee47c23d00$export$2e2bcd8739ae039 = $e1fc32ee47c23d00$var$Account;



var $7xovm = parcelRequire("7xovm");
class $77fa8ab1aa12d8fb$var$Toast {
    constructor(){
        this.container = null;
        this.init();
    }
    /**
     * Initializes toast container in DOM
     */ init() {
        if (!document.getElementById('toast-container')) {
            this.container = document.createElement('div');
            this.container.id = 'toast-container';
            this.container.className = 'toast-container';
            document.body.appendChild(this.container);
        } else this.container = document.getElementById('toast-container');
    }
    /**
     * Shows toast notification
     * @param {string} message - Toast message text
     * @param {string} type - Toast type: 'success', 'error', 'warning', 'info' (default: 'info')
     * @param {number} duration - Auto-close duration in ms (default: 5000, 0 = no auto-close)
     * @returns {HTMLElement} Toast DOM element
     */ show(message, type = 'info', duration = 5000) {
        const toast = document.createElement('div');
        toast.className = `toast toast-${type} rounded-2 py-2 px-3`;
        let icon = '';
        switch(type){
            case 'success':
                icon = '<i class="bi bi-check-circle-fill"></i>';
                break;
            case 'error':
                icon = '<i class="bi bi-x-circle-fill"></i>';
                break;
            case 'warning':
                icon = '<i class="bi bi-exclamation-triangle-fill"></i>';
                break;
            case 'info':
            default:
                icon = '<i class="bi bi-info-circle-fill"></i>';
                break;
        }
        toast.innerHTML = `
            <div class="toast-content d-flex align-items-center gap-2 flex-1">
                <span class="toast-icon">${icon}</span>
                <span class="toast-message">${message}</span>
            </div>
            <button class="toast-close rounded-1 d-flex align-items-center justify-content-center p-1" aria-label="Close">
                <i class="bi bi-x"></i>
            </button>
        `;
        this.container.appendChild(toast);
        requestAnimationFrame(()=>{
            toast.classList.add('toast-show');
        });
        const closeButton = toast.querySelector('.toast-close');
        const closeToast = ()=>{
            this.remove(toast);
        };
        closeButton.addEventListener('click', closeToast);
        if (duration > 0) setTimeout(()=>{
            this.remove(toast);
        }, duration);
        return toast;
    }
    /**
     * Removes toast with animation
     * @param {HTMLElement} toast - Toast DOM element to remove
     */ remove(toast) {
        toast.classList.remove('toast-show');
        toast.classList.add('toast-hide');
        setTimeout(()=>{
            if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 300);
    }
    /**
     * Shows success toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */ success(message, duration = 5000) {
        return this.show(message, 'success', duration);
    }
    /**
     * Shows error toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */ error(message, duration = 5000) {
        return this.show(message, 'error', duration);
    }
    /**
     * Shows warning toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */ warning(message, duration = 5000) {
        return this.show(message, 'warning', duration);
    }
    /**
     * Shows info toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */ info(message, duration = 5000) {
        return this.show(message, 'info', duration);
    }
}
const $77fa8ab1aa12d8fb$var$toast = new $77fa8ab1aa12d8fb$var$Toast();
var $77fa8ab1aa12d8fb$export$2e2bcd8739ae039 = $77fa8ab1aa12d8fb$var$toast;



var $d486cd8337e91fbc$exports = {};
(function(global, factory) {
    $d486cd8337e91fbc$exports = factory();
})($d486cd8337e91fbc$exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});



var $7xovm = parcelRequire("7xovm");


var $gGcib = parcelRequire("gGcib");
/**
 * Google Analytics utility functions
 * Provides helper functions for tracking user interactions
 */ /**
 * Checks if Google Analytics is available
 * @returns {boolean} True if gtag is available
 */ function $95f7cfd86f501f83$var$isAnalyticsAvailable() {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
}
function $95f7cfd86f501f83$export$73d0a139caca1fee(eventName, eventParams = {}) {
    if (!$95f7cfd86f501f83$var$isAnalyticsAvailable()) return;
    try {
        window.gtag('event', eventName, eventParams);
    } catch (error) {
        console.error('Error tracking event:', error);
    }
}
function $95f7cfd86f501f83$export$c8b93a961802392a(packageData) {
    const isTopup = !!packageData.esimTranNo;
    $95f7cfd86f501f83$export$73d0a139caca1fee('add_to_cart', {
        currency: 'USD',
        value: parseFloat(packageData.price) || 0,
        items: [
            {
                item_id: packageData.packageCode,
                item_name: packageData.name || 'Unknown Package',
                price: parseFloat(packageData.price) || 0,
                quantity: 1,
                item_category: isTopup ? 'Topup' : 'eSIM Plan'
            }
        ],
        event_category: 'ecommerce',
        event_label: isTopup ? 'topup' : 'plan'
    });
}
function $95f7cfd86f501f83$export$20e7b1229d45b937(cartItems) {
    const totalValue = cartItems.reduce((sum, item)=>{
        return sum + parseFloat(item.price) * item.quantity;
    }, 0);
    $95f7cfd86f501f83$export$73d0a139caca1fee('begin_checkout', {
        currency: 'USD',
        value: totalValue,
        items: cartItems.map((item)=>({
                item_id: item.packageCode,
                item_name: item.name || 'Unknown Package',
                price: parseFloat(item.price) || 0,
                quantity: item.quantity,
                item_category: item.esimTranNo ? 'Topup' : 'eSIM Plan'
            })),
        event_category: 'ecommerce'
    });
}
function $95f7cfd86f501f83$export$c0440a6856e748cf(transactionId, items, value) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('purchase', {
        transaction_id: transactionId,
        currency: 'USD',
        value: value,
        items: items.map((item)=>({
                item_id: item.packageCode,
                item_name: item.name || 'Unknown Package',
                price: parseFloat(item.price) || 0,
                quantity: item.quantity,
                item_category: item.esimTranNo ? 'Topup' : 'eSIM Plan'
            })),
        event_category: 'ecommerce'
    });
}
function $95f7cfd86f501f83$export$649d4077baf59467(cartItems) {
    const totalValue = cartItems.reduce((sum, item)=>{
        return sum + parseFloat(item.price) * item.quantity;
    }, 0);
    $95f7cfd86f501f83$export$73d0a139caca1fee('checkout_canceled', {
        currency: 'USD',
        value: totalValue,
        items: cartItems.map((item)=>({
                item_id: item.packageCode,
                item_name: item.name || 'Unknown Package',
                price: parseFloat(item.price) || 0,
                quantity: item.quantity
            })),
        event_category: 'ecommerce'
    });
}
function $95f7cfd86f501f83$export$a36542ca35abe00(cartItems) {
    if (cartItems.length === 0) return;
    const totalValue = cartItems.reduce((sum, item)=>{
        return sum + parseFloat(item.price) * item.quantity;
    }, 0);
    $95f7cfd86f501f83$export$73d0a139caca1fee('cart_abandoned', {
        currency: 'USD',
        value: totalValue,
        items: cartItems.map((item)=>({
                item_id: item.packageCode,
                item_name: item.name || 'Unknown Package',
                price: parseFloat(item.price) || 0,
                quantity: item.quantity
            })),
        event_category: 'ecommerce'
    });
}
function $95f7cfd86f501f83$export$682f4f7f34b277fa() {
    $95f7cfd86f501f83$export$73d0a139caca1fee('login', {
        event_category: 'engagement',
        event_label: 'user_login'
    });
}
function $95f7cfd86f501f83$export$e73d5273c65fcb57() {
    $95f7cfd86f501f83$export$73d0a139caca1fee('sign_up', {
        event_category: 'engagement',
        event_label: 'user_registration'
    });
}
function $95f7cfd86f501f83$export$1690bc54873161ff(searchQuery) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('search', {
        search_term: searchQuery,
        event_category: 'engagement',
        event_label: 'plan_search'
    });
}
function $95f7cfd86f501f83$export$16a41f78143d07c1(packageCode, packageName) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('view_item', {
        item_id: packageCode,
        item_name: packageName || 'Unknown Package',
        event_category: 'ecommerce',
        event_label: 'view_package_details'
    });
}
function $95f7cfd86f501f83$export$7774cb5a8d679f78(esimTranNo) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('esim_suspend', {
        event_category: 'engagement',
        event_label: 'esim_management',
        esim_tran_no: esimTranNo
    });
}
function $95f7cfd86f501f83$export$47ff7014d4e09111(esimTranNo) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('esim_unsuspend', {
        event_category: 'engagement',
        event_label: 'esim_management',
        esim_tran_no: esimTranNo
    });
}
function $95f7cfd86f501f83$export$726abd6ad073ab70(esimTranNo) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('topup_click', {
        event_category: 'engagement',
        event_label: 'topup_initiated',
        esim_tran_no: esimTranNo
    });
}
function $95f7cfd86f501f83$export$722ffa05901529f6(language) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('language_change', {
        event_category: 'engagement',
        event_label: 'language_selection',
        language: language
    });
}
function $95f7cfd86f501f83$export$a8d11107f517b60e() {
    $95f7cfd86f501f83$export$73d0a139caca1fee('faq_view', {
        event_category: 'engagement',
        event_label: 'faq_section'
    });
}
function $95f7cfd86f501f83$export$d3f3b943f53ff6ce(faqNumber) {
    $95f7cfd86f501f83$export$73d0a139caca1fee('faq_open', {
        event_category: 'engagement',
        event_label: 'faq_interaction',
        faq_number: faqNumber
    });
}


function $edd17143013384ea$export$bbbeede16db65336(store, sharedElements, callbacks) {
    const searchInput = document.getElementById('locationSearch');
    const dropdown = document.getElementById('autocompleteDropdown');
    const tagsContainer = document.getElementById('tagsContainer');
    const plansSelectionSection = document.getElementById('plansSelectionSection');
    const matchingPlansSection = document.getElementById('matchingPlansSection');
    const matchingPlansContainer = document.getElementById('matchingPlansContainer');
    const durationSection = document.getElementById('durationSection');
    const durationContainer = document.getElementById('durationContainer');
    const dataPackagesSection = document.getElementById('dataPackagesSection');
    const dataPackagesContainer = document.getElementById('dataPackagesContainer');
    const packageDetailsSidebar = document.getElementById('packageDetailsSidebar');
    const packageDetailsBody = document.getElementById('packageDetailsBody');
    const topupPlansSection = document.getElementById('topupPlansSection');
    const topupPlansContainer = document.getElementById('topupPlansContainer');
    const favoritesSection = document.getElementById('favoritesSection');
    const favoritesContainer = document.getElementById('favoritesContainer');
    const { sidebarOverlay: sidebarOverlay } = sharedElements;
    const { renderCart: renderCart, openCart: openCart } = callbacks;
    /**
     * Loads countries based on current language
     */ async function loadCountries() {
        try {
            const isSpanish = (0, $7xovm.default).getLanguage() === 'es';
            if (isSpanish) {
                await store.loadCountriesFromJson();
                setTimeout(async ()=>{
                    try {
                        await store.loadAllLocations();
                    } catch (error) {
                        console.error('Error loading locations (delayed):', error);
                    }
                }, 1000);
            } else await store.loadAllLocations();
        } catch (error) {
            console.error('Error loading countries:', error);
        }
    }
    /**
     * Loads and displays favorite plans
     */ async function loadFavorites() {
        try {
            const favoritesResponse = await store.provider.favorites();
            if (!favoritesResponse.success || !favoritesResponse.obj?.packageList || favoritesResponse.obj.packageList.length === 0) {
                if (favoritesSection) favoritesSection.classList.add('hidden');
                return;
            }
            const favoritePlans = favoritesResponse.obj.packageList;
            renderFavorites(favoritePlans);
        } catch (error) {
            console.error('Error loading favorites:', error);
            if (favoritesSection) favoritesSection.classList.add('hidden');
        }
    }
    /**
     * Renders favorite plans cards
     * @param {Array} plans - Array of favorite plan objects
     */ function renderFavorites(plans) {
        if (!favoritesContainer || !favoritesSection) return;
        favoritesContainer.innerHTML = '';
        const template = document.getElementById('template-favorite-card');
        if (!template) return;
        const templateHtml = template.innerHTML;
        // Sort plans by price ascending
        const sortedPlans = [
            ...plans
        ].sort((a, b)=>(a.price || 0) - (b.price || 0));
        sortedPlans.forEach((plan)=>{
            const price = (plan.price / 10000).toFixed(2);
            const displayVolume = (0, $gGcib.formatVolume)(plan.volume);
            const locationCode = plan.locationCode || plan.location;
            const locationName = store.getLocationName(locationCode) || locationCode;
            const flagIcon = store.getFlagIcon(locationCode);
            // Translate duration unit
            let durationUnit = plan.durationUnit?.toLowerCase() || 'days';
            durationUnit = (0, $gGcib.translateDayText)(durationUnit, plan.duration);
            const data = {
                packageCode: plan.packageCode,
                locationName: (0, $gGcib.translateDayText)(locationName),
                flagIcon: flagIcon,
                price: price,
                displayVolume: displayVolume,
                duration: plan.duration,
                durationUnit: durationUnit,
                allowsTopUp: plan.supportTopUpType === 2
            };
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const card = tempDiv.firstElementChild;
            const addToCartButton = card.querySelector('.favorite-card-add-to-cart');
            const viewDetailsButton = card.querySelector('.favorite-card-view-details');
            addToCartButton.addEventListener('click', (e)=>{
                e.stopPropagation();
                addPackageToCart(plan);
            });
            viewDetailsButton.addEventListener('click', (e)=>{
                e.stopPropagation();
                (0, $95f7cfd86f501f83$export$16a41f78143d07c1)(plan.packageCode, displayVolume);
                showPackageDetailsSidebar([
                    plan
                ], displayVolume);
            });
            favoritesContainer.appendChild(card);
        });
        (0, $7xovm.default).updatePage();
        favoritesSection.classList.remove('hidden');
    }
    /**
     * Initializes eSIM module
     */ async function init() {
        searchInput.disabled = true;
        searchInput.placeholder = (0, $7xovm.default).t('loading');
        try {
            const loadPromises = [
                store.loadAllPlans(),
                loadCountries()
            ];
            await Promise.all(loadPromises);
            // Load favorites after plans are loaded
            await loadFavorites();
            searchInput.disabled = false;
            searchInput.placeholder = (0, $7xovm.default).t('searchPlaceholder');
        } catch (error) {
            console.error('Error initializing app:', error);
            searchInput.disabled = false;
            searchInput.placeholder = (0, $7xovm.default).t('searchPlaceholder');
        }
    }
    /**
     * Adds country tag to selection
     * @param {Object} location - Location object
     */ function addCountryTag(location) {
        if (store.addCountry(location)) {
            renderTags();
            filterAndDisplayPlans();
            searchInput.value = '';
            (0, $gGcib.hideDropdown)(dropdown);
            searchInput.focus();
        }
    }
    /**
     * Removes country tag from selection
     * @param {string} locationCode - Location code to remove
     */ function removeCountryTag(locationCode) {
        const currentLocation = store.getCurrentLocation();
        if (currentLocation && currentLocation.plans) {
            const hasMatchingPlan = currentLocation.plans.some((plan)=>{
                const planLocationCode = plan.locationCode || plan.location;
                return planLocationCode === locationCode;
            });
            if (hasMatchingPlan) store.clearCurrentLocation();
        }
        store.removeCountry(locationCode);
        document.querySelectorAll('.location-plan-card').forEach((c)=>c.classList.remove('active'));
        document.querySelectorAll('.duration-card').forEach((c)=>c.classList.remove('active'));
        durationContainer.innerHTML = '';
        dataPackagesContainer.innerHTML = '';
        plansSelectionSection.classList.add('hidden');
        durationSection.classList.add('hidden');
        dataPackagesSection.classList.add('hidden');
        renderTags();
        filterAndDisplayPlans();
    }
    /**
     * Renders country tags
     */ function renderTags() {
        tagsContainer.innerHTML = '';
        store.getSelectedCountries().forEach((location)=>{
            const template = document.getElementById('template-country-tag');
            const templateHtml = template.innerHTML;
            const data = store.prepareTagData(location);
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const tag = tempDiv.firstElementChild;
            tag.querySelector('.tag-remove').addEventListener('click', ()=>removeCountryTag(location.code));
            tagsContainer.appendChild(tag);
        });
    }
    /**
     * Filters and displays plans based on selected countries
     */ function filterAndDisplayPlans() {
        const plansByLocation = store.filterPlans();
        if (!plansByLocation) {
            plansSelectionSection.classList.add('hidden');
            matchingPlansSection.classList.add('hidden');
            return;
        }
        if (Object.keys(plansByLocation).length === 0) {
            const template = document.getElementById('template-empty-state');
            const templateHtml = template.innerHTML;
            const data = {
                icon: "\uD83D\uDCE6",
                text: (0, $7xovm.default).t('noPlansFound')
            };
            matchingPlansContainer.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            plansSelectionSection.classList.remove('hidden');
            matchingPlansSection.classList.remove('hidden');
            return;
        }
        renderMatchingPlans(plansByLocation);
        plansSelectionSection.classList.remove('hidden');
        matchingPlansSection.classList.remove('hidden');
        durationSection.classList.add('hidden');
        dataPackagesSection.classList.add('hidden');
    }
    /**
     * Renders matching plans by location
     * @param {Object} plansByLocation - Plans grouped by location
     */ function renderMatchingPlans(plansByLocation) {
        matchingPlansContainer.innerHTML = '';
        const template = document.getElementById('template-location-plan-card');
        const templateHtml = template.innerHTML;
        const plansData = store.prepareMatchingPlansData(plansByLocation);
        if (!plansData) return;
        plansData.forEach((data)=>{
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const card = tempDiv.firstElementChild;
            card.addEventListener('click', ()=>{
                document.querySelectorAll('.location-plan-card').forEach((c)=>c.classList.remove('active'));
                card.classList.add('active');
                selectLocation(data.locationData);
            });
            matchingPlansContainer.appendChild(card);
        });
    }
    /**
     * Selects location and shows duration options
     * @param {Object} locationData - Location data with plans
     */ function selectLocation(locationData) {
        store.setCurrentLocation(locationData);
        const durations = store.prepareDurationsData(locationData);
        durationContainer.innerHTML = '';
        const template = document.getElementById('template-duration-card');
        const templateHtml = template.innerHTML;
        durations.forEach((duration)=>{
            const data = {
                duration: duration.duration,
                durationUnit: (0, $gGcib.translateDayText)(duration.durationUnit),
                display: (0, $gGcib.translateDayText)(duration.display, duration.duration),
                priceRange: duration.priceRange,
                packageCount: duration.packageCount,
                packageText: duration.packageText
            };
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const card = tempDiv.firstElementChild;
            card.addEventListener('click', ()=>{
                document.querySelectorAll('.duration-card').forEach((c)=>c.classList.remove('active'));
                card.classList.add('active');
                selectDuration(duration.duration, duration.durationUnit);
            });
            durationContainer.appendChild(card);
        });
        durationSection.classList.remove('hidden');
        dataPackagesSection.classList.add('hidden');
        durationSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    /**
     * Selects duration and shows package options
     * @param {number} duration - Duration value
     * @param {string} unit - Duration unit
     */ function selectDuration(duration, unit) {
        const packagesData = store.preparePackagesData(duration, unit);
        dataPackagesContainer.innerHTML = '';
        const template = document.getElementById('template-package-card');
        const templateHtml = template.innerHTML;
        packagesData.forEach((packageData)=>{
            const data = {
                volume: packageData.volume,
                priceRange: packageData.priceRange
            };
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const card = tempDiv.firstElementChild;
            const addToCartButton = card.querySelector('.package-card-add-to-cart');
            const viewDetailsButton = card.querySelector('.package-card-view-details');
            addToCartButton.addEventListener('click', (e)=>{
                e.stopPropagation();
                if (packageData.plans.length > 0) addPackageToCart(packageData.plans[0]);
            });
            viewDetailsButton.addEventListener('click', (e)=>{
                e.stopPropagation();
                if (packageData.plans.length > 0) {
                    const plan = packageData.plans[0];
                    (0, $95f7cfd86f501f83$export$16a41f78143d07c1)(plan.packageCode, packageData.volume);
                }
                showPackageDetailsSidebar(packageData.plans, packageData.volume);
            });
            dataPackagesContainer.appendChild(card);
        });
        (0, $7xovm.default).updatePage();
        dataPackagesSection.classList.remove('hidden');
        dataPackagesSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    /**
     * Shows package details sidebar
     * @param {Array} plans - Array of plan objects
     * @param {string} volume - Volume display text
     */ function showPackageDetailsSidebar(plans, volume) {
        const packages = store.preparePackageDetailsData(plans);
        const template = document.getElementById('template-package-detail-card');
        const templateHtml = template.innerHTML;
        packageDetailsBody.innerHTML = '';
        // Track view_item for the first plan
        if (packages.length > 0 && packages[0].packageCode) (0, $95f7cfd86f501f83$export$16a41f78143d07c1)(packages[0].packageCode, volume);
        packages.forEach((pkg)=>{
            pkg.name = (0, $gGcib.translateDayText)(pkg.name);
            pkg.durationUnit = (0, $gGcib.translateDayText)(pkg.durationUnit, pkg.duration);
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, pkg);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const detailCard = tempDiv.firstElementChild;
            if (pkg.hasCountries) {
                const countriesSection = document.createElement('div');
                countriesSection.className = 'package-countries-section pt-2 mt-2';
                countriesSection.innerHTML = `<h4>${(0, $7xovm.default).t('countriesIncluded')}</h4><div class="package-countries-list d-flex flex-wrap gap-1"></div>`;
                const countriesList = countriesSection.querySelector('.package-countries-list');
                const countryTagTemplate = document.getElementById('template-country-tag');
                const countryTagTemplateHtml = countryTagTemplate.innerHTML;
                pkg.countries.forEach((country)=>{
                    const data = {
                        code: country.code,
                        name: (0, $gGcib.translateDayText)(country.name),
                        flagIcon: country.flagIcon
                    };
                    const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(countryTagTemplateHtml, data);
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    const countryTag = tempDiv.firstElementChild;
                    const removeButton = countryTag.querySelector('.tag-remove');
                    if (removeButton) removeButton.remove();
                    countriesList.appendChild(countryTag);
                });
                detailCard.appendChild(countriesSection);
            }
            packageDetailsBody.appendChild(detailCard);
        });
        (0, $7xovm.default).updatePage();
        sidebarOverlay.classList.remove('hidden');
        packageDetailsSidebar.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    }
    /**
     * Closes package details sidebar
     */ function closePackageDetailsSidebarFunc() {
        packageDetailsSidebar.classList.add('hidden');
        document.body.style.overflow = '';
    }
    function showSuggestions(locations) {
        if (!locations.length) {
            (0, $gGcib.hideDropdown)(dropdown);
            return;
        }
        dropdown.innerHTML = '';
        const template = document.getElementById('template-autocomplete-item');
        const templateHtml = template.innerHTML;
        locations.forEach((location)=>{
            const isRegional = location.type === 2;
            const subLocationCount = location.subLocationList ? location.subLocationList.length : 0;
            const typeText = isRegional ? `${(0, $7xovm.default).t('region')} (${subLocationCount} ${(0, $7xovm.default).t('country').toLowerCase()}s)` : (0, $7xovm.default).t('country');
            const data = {
                name: location.name,
                code: location.code,
                typeText: typeText,
                flagIcon: store.getFlagIcon(location.code)
            };
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const item = tempDiv.firstElementChild;
            item.addEventListener('click', ()=>{
                addCountryTag(location);
            });
            dropdown.appendChild(item);
        });
        dropdown.classList.remove('hidden');
    }
    /**
     * Adds package to cart
     * @param {Object} plan - Plan object
     */ function addPackageToCart(plan) {
        const packageDetails = store.preparePackageDetailsData([
            plan
        ])[0];
        const packageData = {
            packageCode: packageDetails.packageCode,
            name: (0, $gGcib.translateDayText)(packageDetails.name),
            price: packageDetails.price,
            charge: packageDetails.charge || 0,
            displayVolume: packageDetails.displayVolume,
            duration: packageDetails.duration,
            durationUnit: (0, $gGcib.translateDayText)(packageDetails.durationUnit, packageDetails.duration),
            hasSpeed: packageDetails.hasSpeed,
            speed: packageDetails.speed,
            smsStatus: packageDetails.smsStatus,
            dataType: packageDetails.dataType,
            activeType: packageDetails.activeType,
            operatorList: packageDetails.operatorList,
            supportTopUpType: packageDetails.supportTopUpType,
            originalPlan: plan
        };
        store.addToCart(packageData);
        (0, $95f7cfd86f501f83$export$c8b93a961802392a)(packageData);
        renderCart();
        openCart();
    }
    /**
     * Sets up event listeners
     */ function setupEventListeners() {
        searchInput.addEventListener('input', (e)=>{
            const query = e.target.value.trim();
            if (query.length === 0) {
                (0, $gGcib.hideDropdown)(dropdown);
                return;
            }
            if (topupPlansSection && topupPlansContainer) {
                topupPlansContainer.innerHTML = '';
                topupPlansSection.classList.add('hidden');
            }
            if (favoritesSection) favoritesSection.classList.add('hidden');
            if (query.length >= 1) {
                const isSpanish = (0, $7xovm.default).getLanguage() === 'es';
                const results = store.searchLocations(query, isSpanish);
                showSuggestions(results);
                (0, $95f7cfd86f501f83$export$1690bc54873161ff)(query);
            }
        });
        document.addEventListener('click', (e)=>{
            if (!searchInput.contains(e.target) && !dropdown.contains(e.target)) (0, $gGcib.hideDropdown)(dropdown);
        });
    }
    setupEventListeners();
    init();
    /**
     * Refreshes current sections based on store state
     */ function refreshCurrentSections() {
        const currentLocation = store.getCurrentLocation();
        if (currentLocation) selectLocation(currentLocation);
        else filterAndDisplayPlans();
    }
    /**
     * Shows topup plans in the main container
     * @param {Array} plans - Array of topup plans
     * @param {string} esimTranNo - eSIM transaction number
     */ /**
     * Shows topup plans in the main container
     * @param {Array} plans - Array of topup plans
     * @param {string} esimTranNo - eSIM transaction number
     */ function showTopupPlans(plans, esimTranNo) {
        if (!store || !plans || plans.length === 0) {
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('noTopupPlansAvailable'));
            return;
        }
        if (!topupPlansSection || !topupPlansContainer) {
            console.error('Topup plans section elements not found');
            return;
        }
        (0, $95f7cfd86f501f83$export$726abd6ad073ab70)(esimTranNo);
        if (searchInput) searchInput.value = '';
        (0, $gGcib.hideDropdown)(dropdown);
        if (tagsContainer) tagsContainer.innerHTML = '';
        store.selectedCountries = [];
        store.clearCurrentLocation();
        if (plansSelectionSection) plansSelectionSection.classList.add('hidden');
        if (matchingPlansSection) matchingPlansSection.classList.add('hidden');
        if (durationSection) durationSection.classList.add('hidden');
        if (dataPackagesSection) dataPackagesSection.classList.add('hidden');
        const userEsimsSidebar = document.getElementById('userEsimsSidebar');
        if (userEsimsSidebar) userEsimsSidebar.classList.add('hidden');
        if (sidebarOverlay) sidebarOverlay.classList.add('hidden');
        document.body.style.overflow = '';
        const packages = store.preparePackageDetailsData(plans);
        const template = document.getElementById('template-topup-package-card');
        if (!template) {
            console.error('Topup package card template not found');
            return;
        }
        const templateHtml = template.innerHTML;
        topupPlansContainer.innerHTML = '';
        packages.forEach((pkg, index)=>{
            pkg.name = (0, $gGcib.translateDayText)(pkg.name);
            pkg.durationUnit = (0, $gGcib.translateDayText)(pkg.durationUnit, pkg.duration);
            const data = {
                price: pkg.price,
                displayVolume: pkg.displayVolume,
                duration: pkg.duration,
                durationUnit: pkg.durationUnit,
                packageCode: pkg.packageCode
            };
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const card = tempDiv.firstElementChild;
            const addToCartButton = card.querySelector('.topup-package-add-to-cart');
            const viewDetailsButton = card.querySelector('.topup-package-view-details');
            if (addToCartButton) addToCartButton.addEventListener('click', (e)=>{
                e.stopPropagation();
                if (!store) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('storeNotAvailable'));
                    return;
                }
                const originalPlan = plans[index];
                const packageData = {
                    packageCode: pkg.packageCode,
                    name: pkg.name,
                    price: parseFloat(pkg.price),
                    charge: parseFloat(pkg.charge) || 0,
                    displayVolume: pkg.displayVolume,
                    duration: pkg.duration,
                    durationUnit: pkg.durationUnit,
                    hasSpeed: pkg.hasSpeed,
                    speed: pkg.speed,
                    smsStatus: pkg.smsStatus,
                    dataType: pkg.dataType,
                    activeType: pkg.activeType,
                    operatorList: pkg.operatorList,
                    supportTopUpType: pkg.supportTopUpType,
                    esimTranNo: esimTranNo,
                    originalPlan: originalPlan
                };
                store.addToCart(packageData);
                (0, $95f7cfd86f501f83$export$c8b93a961802392a)(packageData);
                if (renderCart) renderCart();
            });
            if (viewDetailsButton) viewDetailsButton.addEventListener('click', (e)=>{
                e.stopPropagation();
                if (packageDetailsSidebar && packageDetailsBody) {
                    const detailTemplate = document.getElementById('template-package-detail-card');
                    if (detailTemplate) {
                        packageDetailsBody.innerHTML = '';
                        const detailHtml = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(detailTemplate.innerHTML, pkg);
                        const detailTempDiv = document.createElement('div');
                        detailTempDiv.innerHTML = detailHtml;
                        const detailCard = detailTempDiv.firstElementChild;
                        if (pkg.hasCountries) {
                            const countriesSection = document.createElement('div');
                            countriesSection.className = 'package-countries-section pt-2 mt-2';
                            countriesSection.innerHTML = `<h4>${(0, $7xovm.default).t('countriesIncluded')}</h4><div class="package-countries-list d-flex flex-wrap gap-1"></div>`;
                            const countriesList = countriesSection.querySelector('.package-countries-list');
                            const countryTagTemplate = document.getElementById('template-country-tag');
                            if (countryTagTemplate) {
                                const countryTagTemplateHtml = countryTagTemplate.innerHTML;
                                pkg.countries.forEach((country)=>{
                                    const countryData = {
                                        code: country.code,
                                        name: (0, $gGcib.translateDayText)(country.name),
                                        flagIcon: country.flagIcon
                                    };
                                    const countryHtml = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(countryTagTemplateHtml, countryData);
                                    const countryTempDiv = document.createElement('div');
                                    countryTempDiv.innerHTML = countryHtml;
                                    const countryTag = countryTempDiv.firstElementChild;
                                    const removeButton = countryTag.querySelector('.tag-remove');
                                    if (removeButton) removeButton.remove();
                                    countriesList.appendChild(countryTag);
                                });
                                detailCard.appendChild(countriesSection);
                            }
                        }
                        packageDetailsBody.appendChild(detailCard);
                        (0, $7xovm.default).updatePage();
                        packageDetailsSidebar.classList.remove('hidden');
                        if (sidebarOverlay) sidebarOverlay.classList.remove('hidden');
                    }
                }
            });
            topupPlansContainer.appendChild(card);
        });
        (0, $7xovm.default).updatePage();
        topupPlansSection.classList.remove('hidden');
        topupPlansSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    return {
        init: init,
        loadCountries: loadCountries,
        addCountryTag: addCountryTag,
        removeCountryTag: removeCountryTag,
        renderTags: renderTags,
        filterAndDisplayPlans: filterAndDisplayPlans,
        renderMatchingPlans: renderMatchingPlans,
        selectLocation: selectLocation,
        selectDuration: selectDuration,
        showPackageDetailsSidebar: showPackageDetailsSidebar,
        closePackageDetailsSidebarFunc: closePackageDetailsSidebarFunc,
        showSuggestions: showSuggestions,
        addPackageToCart: addPackageToCart,
        refreshCurrentSections: refreshCurrentSections,
        showTopupPlans: showTopupPlans
    };
}




var $7xovm = parcelRequire("7xovm");


var $gGcib = parcelRequire("gGcib");

function $b86113196e618a42$export$e838c4b04241f74(cart, domElements, callbacks) {
    const { cartSidebar: cartSidebar, cartToggleButton: cartToggleButton, cartBody: cartBody, cartBuyButton: cartBuyButton, cartBadge: cartBadge, sidebarOverlay: sidebarOverlay } = domElements;
    const { onCheckout: onCheckout, onOpenRegister: onOpenRegister, checkOtherSidebars: checkOtherSidebars, account: account } = callbacks || {};
    if (!account) console.error('Account is required for cart checkout');
    const cartCheckoutSection = document.getElementById('cartCheckoutSection');
    const cartVerificationSection = document.getElementById('cartVerificationSection');
    const cartEmail = document.getElementById('cartEmail');
    const cartCode = document.getElementById('cartCode');
    const cartEmailGroup = document.getElementById('cartEmailGroup');
    const cartCodeGroup = document.getElementById('cartCodeGroup');
    const cartSendCodeButton = document.getElementById('cartSendCodeButton');
    const cartVerifyCodeButton = document.getElementById('cartVerifyCodeButton');
    let cartEmailSent = false;
    let checkoutEmail = '';
    function renderCart() {
        const cartItems = cart.getCart();
        const template = document.getElementById('template-cart-item');
        const templateHtml = template.innerHTML;
        if (cartItems.length === 0) {
            cartBody.innerHTML = `<div class="cart-empty"><p>${(0, $7xovm.default).t('cartEmpty')}</p></div>`;
            cartBuyButton.disabled = true;
            cartBadge.classList.add('hidden');
            updateCartTotal();
            return;
        }
        cartBody.innerHTML = '';
        cartItems.forEach((item)=>{
            const price = parseFloat(item.price) || 0;
            const subtotal = (price * item.quantity).toFixed(2);
            const { speed: speed, hasSpeed: hasSpeed, ...itemWithoutSpeed } = item;
            const data = {
                ...itemWithoutSpeed,
                name: (0, $gGcib.translateDayText)(item.name),
                durationUnit: (0, $gGcib.translateDayText)(item.durationUnit, item.duration),
                price: price.toFixed(2),
                subtotal: subtotal
            };
            const html = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, data);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const cartItem = tempDiv.firstElementChild;
            cartItem.querySelector('.cart-item-remove').addEventListener('click', ()=>{
                cart.removeFromCart(item.packageCode, 'packageCode');
                renderCart();
            });
            cartItem.querySelectorAll('.quantity-btn').forEach((btn)=>{
                btn.addEventListener('click', (e)=>{
                    const action = e.target.dataset.action;
                    const currentQuantity = item.quantity;
                    if (action === 'increase') cart.updateCartQuantity(item.packageCode, currentQuantity + 1, 'packageCode');
                    else if (action === 'decrease') cart.updateCartQuantity(item.packageCode, currentQuantity - 1, 'packageCode');
                    renderCart();
                });
            });
            cartBody.appendChild(cartItem);
        });
        (0, $7xovm.default).updatePage();
        const totalItems = cart.getTotalItems();
        if (totalItems > 0) {
            cartBadge.textContent = totalItems;
            cartBadge.classList.remove('hidden');
        } else cartBadge.classList.add('hidden');
        cartBuyButton.disabled = cartItems.length === 0;
        updateCartTotal();
    }
    function updateCartTotal() {
        const cartItems = cart.getCart();
        const total = cart.getCartTotal('price').toFixed(2);
        const totalElement = document.querySelector('.cart-total-amount');
        if (totalElement) totalElement.textContent = `$${total}`;
        // Calculate total processing fee if there are charges
        const totalCharge = cartItems.reduce((sum, item)=>{
            // charge can be a string (from preparePackageDetailsData) or number
            let charge = 0;
            if (item.charge !== undefined && item.charge !== null) charge = typeof item.charge === 'string' ? parseFloat(item.charge) : item.charge;
            return sum + charge * item.quantity;
        }, 0);
        const processingFeeSection = document.getElementById('cartProcessingFee');
        const feeTotalElement = document.querySelector('.cart-fee-total');
        if (totalCharge > 0 && processingFeeSection && feeTotalElement) {
            feeTotalElement.textContent = `$${totalCharge.toFixed(2)}`;
            processingFeeSection.classList.remove('hidden');
        } else if (processingFeeSection) processingFeeSection.classList.add('hidden');
    }
    function resetCartVerification() {
        cartEmailSent = false;
        checkoutEmail = '';
        cartCheckoutSection.classList.remove('hidden');
        cartVerificationSection.classList.add('hidden');
        cartEmailGroup.classList.remove('hidden');
        cartCodeGroup.classList.add('hidden');
        cartSendCodeButton.classList.remove('hidden');
        cartVerifyCodeButton.classList.add('hidden');
        cartEmail.value = '';
        cartCode.value = '';
        cartCode.removeAttribute('required');
    }
    function openCart() {
        cartSidebar.classList.remove('hidden');
        sidebarOverlay.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        resetCartVerification();
    }
    function closeCart() {
        // Track cart abandonment if cart has items
        const cartItems = cart.getCart();
        if (cartItems.length > 0) (0, $95f7cfd86f501f83$export$a36542ca35abe00)(cartItems);
        cartSidebar.classList.add('hidden');
        if (checkOtherSidebars) {
            const hasOpenSidebar = checkOtherSidebars();
            if (!hasOpenSidebar) {
                sidebarOverlay.classList.add('hidden');
                document.body.style.overflow = '';
            }
        } else {
            sidebarOverlay.classList.add('hidden');
            document.body.style.overflow = '';
        }
    }
    async function handleSendCode() {
        const email = cartEmail.value.trim();
        if (!email) {
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('emailRequired'));
            return;
        }
        try {
            await account.requestCode(email);
            checkoutEmail = email;
            cartEmailSent = true;
            cartEmailGroup.classList.add('hidden');
            cartCodeGroup.classList.remove('hidden');
            cartCode.setAttribute('required', 'required');
            cartSendCodeButton.classList.add('hidden');
            cartVerifyCodeButton.classList.remove('hidden');
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('codeSent'));
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('codeSendFailed'));
        }
    }
    async function handleVerifyCode() {
        const code = cartCode.value.trim();
        if (!code || code.length !== 6) {
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('invalidCode'));
            return;
        }
        try {
            await account.verifyCodeForCheckout(checkoutEmail, code);
            // Establecer el idioma del usuario si está definido
            const user = account.getCurrentUser();
            if (user && user.language) {
                (0, $7xovm.default).setLanguage(user.language);
                if (window.updateLanguageButtons) window.updateLanguageButtons();
            }
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('codeVerified'));
            const cartItems = cart.getCart();
            if (onCheckout) try {
                await onCheckout(cartItems);
            } catch (error) {
                console.error('Error creating checkout session:', error);
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('errorProcessingPayment'));
            }
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('codeVerificationFailed'));
        }
    }
    function setupEventListeners() {
        cartToggleButton.addEventListener('click', ()=>{
            openCart();
        });
        cartBuyButton.addEventListener('click', ()=>{
            const cartItems = cart.getCart();
            if (cartItems.length === 0) return;
            (0, $95f7cfd86f501f83$export$20e7b1229d45b937)(cartItems);
            if (account && account.isAuthenticated && account.isAuthenticated()) {
                if (onCheckout) onCheckout(cartItems).catch((error)=>{
                    console.error('Error creating checkout session:', error);
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('errorProcessingPayment'));
                });
            } else if (account) {
                cartCheckoutSection.classList.add('hidden');
                cartVerificationSection.classList.remove('hidden');
            } else (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error('Account service is not available');
        });
        if (cartSendCodeButton) cartSendCodeButton.addEventListener('click', async (e)=>{
            e.preventDefault();
            await handleSendCode();
        });
        if (cartVerifyCodeButton) cartVerifyCodeButton.addEventListener('click', async (e)=>{
            e.preventDefault();
            await handleVerifyCode();
        });
        if (cartEmail) cartEmail.addEventListener('keypress', async (e)=>{
            if (e.key === 'Enter' && !cartEmailSent) {
                e.preventDefault();
                await handleSendCode();
            }
        });
        if (cartCode) cartCode.addEventListener('keypress', async (e)=>{
            if (e.key === 'Enter' && cartEmailSent) {
                e.preventDefault();
                await handleVerifyCode();
            }
        });
    }
    setupEventListeners();
    renderCart();
    return {
        renderCart: renderCart,
        updateCartTotal: updateCartTotal,
        openCart: openCart,
        closeCart: closeCart
    };
}




var $7xovm = parcelRequire("7xovm");


var $gGcib = parcelRequire("gGcib");



function $0fc4247925ff5a5f$export$6d3c879d7a79980d(account, sharedDomElements, callbacks) {
    const { sidebarOverlay: sidebarOverlay } = sharedDomElements;
    let { renderCart: renderCart, onLogout: onLogout, store: store, addPackageToCart: addPackageToCart, showTopupPlans: showTopupPlans } = callbacks || {};
    const provider = new (0, $42f96fa8e433dde8$export$2e2bcd8739ae039)();
    let cachedEsims = [];
    /**
     * Gets "used" bytes for display. API may send orderUsage (used) or dataLeft/data_left (remaining in bytes).
     * When dataLeft is present, used = totalVolume - dataLeft so the display matches the provider.
     * @param {{ totalVolume?: number, orderUsage?: number, dataLeft?: number, data_left?: number }} record
     * @returns {number} Used bytes
     */ function getUsedBytes(record) {
        if (!record) return 0;
        const total = typeof record.totalVolume === 'number' ? record.totalVolume : 0;
        const dataLeft = record.dataLeft ?? record.data_left;
        if (dataLeft != null && typeof dataLeft === 'number') return Math.max(0, total - dataLeft);
        if (record.orderUsage != null && typeof record.orderUsage === 'number') return record.orderUsage;
        return 0;
    }
    const authSidebar = document.getElementById('authSidebar');
    const loginButton = document.getElementById('loginButton');
    const editProfileMenuButton = document.getElementById('editProfileMenuButton');
    const loginTab = document.getElementById('loginTab');
    const registerTab = document.getElementById('registerTab');
    const logoutButton = document.getElementById('logoutButton');
    const userInfo = document.getElementById('userInfo');
    const loginForm = document.getElementById('loginForm');
    const registerForm = document.getElementById('registerForm');
    const emailVerificationMessage = document.getElementById('emailVerificationMessage');
    const editProfileButton = document.getElementById('editProfileButton');
    const resendVerificationEmailButton = document.getElementById('resendVerificationEmailButton');
    const editProfileSidebar = document.getElementById('editProfileSidebar');
    const editProfileForm = document.getElementById('editProfileForm');
    const editProfileName = document.getElementById('editProfileName');
    const editProfileLastname = document.getElementById('editProfileLastname');
    const editProfileEmail = document.getElementById('editProfileEmail');
    const editProfileLanguage = document.getElementById('editProfileLanguage');
    const loginEmail = document.getElementById('loginEmail');
    const loginCode = document.getElementById('loginCode');
    const loginEmailGroup = document.getElementById('loginEmailGroup');
    const loginCodeGroup = document.getElementById('loginCodeGroup');
    const loginSubmitButton = document.getElementById('loginSubmitButton');
    const loginChangeEmailButton = document.getElementById('loginChangeEmailButton');
    const loginChangeEmailGroup = document.getElementById('loginChangeEmailGroup');
    const registerName = document.getElementById('registerName');
    const registerLastname = document.getElementById('registerLastname');
    const registerEmail = document.getElementById('registerEmail');
    const registerCode = document.getElementById('registerCode');
    const registerNameGroup = document.getElementById('registerNameGroup');
    const registerLastnameGroup = document.getElementById('registerLastnameGroup');
    const registerEmailGroup = document.getElementById('registerEmailGroup');
    const registerCodeGroup = document.getElementById('registerCodeGroup');
    const registerSubmitButton = document.getElementById('registerSubmitButton');
    let loginEmailSent = false;
    let registerEmailSent = false;
    const userEsimsButton = document.getElementById('userEsimsButton');
    const userEsimsSidebar = document.getElementById('userEsimsSidebar');
    const userEsimsSidebarBody = document.getElementById('userEsimsSidebarBody');
    const subtitle = document.querySelector('.subtitle');
    /**
     * Resets login form to initial state
     */ function resetLoginForm() {
        loginEmailSent = false;
        loginEmailGroup.style.opacity = '1';
        loginEmailGroup.style.pointerEvents = 'auto';
        loginEmail.disabled = false;
        loginCodeGroup.style.opacity = '0.5';
        loginCodeGroup.style.pointerEvents = 'none';
        loginCode.value = '';
        loginCode.disabled = true;
        loginCode.removeAttribute('required');
        if (loginChangeEmailGroup) loginChangeEmailGroup.style.display = 'none';
        loginSubmitButton.setAttribute('data-i18n', 'sendCode');
        (0, $7xovm.default).updatePage();
    }
    /**
     * Resets register form to initial state
     */ function resetRegisterForm() {
        registerEmailSent = false;
        registerNameGroup.classList.remove('hidden');
        registerLastnameGroup.classList.remove('hidden');
        registerEmailGroup.classList.remove('hidden');
        registerCodeGroup.classList.add('hidden');
        registerCode.value = '';
        registerCode.removeAttribute('required');
        registerSubmitButton.setAttribute('data-i18n', 'sendCode');
        (0, $7xovm.default).updatePage();
    }
    /**
     * Switches to login tab
     */ function switchToLoginTab() {
        loginTab.classList.add('active');
        registerTab.classList.remove('active');
        loginForm.classList.add('auth-form-active');
        registerForm.classList.remove('auth-form-active');
        loginForm.reset();
        registerForm.reset();
        resetLoginForm();
        resetRegisterForm();
    }
    /**
     * Switches to register tab
     */ function switchToRegisterTab() {
        registerTab.classList.add('active');
        loginTab.classList.remove('active');
        registerForm.classList.add('auth-form-active');
        loginForm.classList.remove('auth-form-active');
        loginForm.reset();
        registerForm.reset();
        resetLoginForm();
        resetRegisterForm();
    }
    /**
     * Opens authentication sidebar
     */ function openAuthSidebarFunc() {
        sidebarOverlay.classList.remove('hidden');
        authSidebar.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        switchToLoginTab();
    }
    /**
     * Opens register sidebar
     */ function openRegisterSidebarFunc() {
        sidebarOverlay.classList.remove('hidden');
        authSidebar.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        switchToRegisterTab();
    }
    /**
     * Closes authentication sidebar
     * @param {boolean} force - Force close even if code was sent
     */ function closeAuthSidebarFunc(force = false) {
        if (!force && (loginEmailSent || registerEmailSent)) return;
        authSidebar.classList.add('hidden');
        const hasOpenSidebar = !editProfileSidebar.classList.contains('hidden') || !userEsimsSidebar.classList.contains('hidden');
        if (!hasOpenSidebar) {
            sidebarOverlay.classList.add('hidden');
            document.body.style.overflow = '';
        }
        loginForm.reset();
        registerForm.reset();
        resetLoginForm();
        resetRegisterForm();
    }
    /**
     * Checks email verification token from URL
     */ async function checkEmailVerification() {
        const urlParams = new URLSearchParams(window.location.search);
        const verifyToken = urlParams.get('token');
        if (verifyToken) {
            window.history.replaceState({}, document.title, window.location.pathname);
            try {
                const result = await account.verifyEmail(verifyToken);
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('emailVerified'));
            } catch (error) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('emailVerificationFailed'));
            }
        }
    }
    /**
     * Loads user eSIMs from API
     */ async function loadUserEsims() {
        if (!account.isAuthenticated()) {
            cachedEsims = [];
            return;
        }
        try {
            const user = account.getCurrentUser();
            if (!user || !user.id) throw new Error('User not found');
            const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.baseUrl;
            const token = account.getToken();
            const purchasesResponse = await fetch(`${baseUrl}/user/${user.id}/purchases`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!purchasesResponse.ok) throw new Error('Failed to load purchases');
            const purchasesData = await purchasesResponse.json();
            let purchases = [];
            if (Array.isArray(purchasesData)) purchases = purchasesData;
            else if (purchasesData && typeof purchasesData === 'object') purchases = purchasesData.purchases || purchasesData.data || purchasesData.items || [];
            if (!Array.isArray(purchases) || purchases.length === 0) {
                cachedEsims = [];
                return;
            }
            const orderNos = [
                ...new Set(purchases.map((p)=>p.esim_order_no).filter(Boolean))
            ];
            if (orderNos.length === 0) {
                cachedEsims = [];
                return;
            }
            const esimQueries = await Promise.all(orderNos.map((orderNo)=>provider.query({
                    orderNo: orderNo,
                    pager: {
                        pageNum: 1,
                        pageSize: 100
                    }
                })));
            const allEsims = [];
            esimQueries.forEach((queryResult, index)=>{
                if (queryResult && queryResult.obj && queryResult.obj.esimList) queryResult.obj.esimList.forEach((esim)=>{
                    allEsims.push({
                        ...esim,
                        orderNo: orderNos[index],
                        orderUsage: esim.orderUsage || '-',
                        totalVolume: esim.totalVolume || '-'
                    });
                });
            });
            cachedEsims = allEsims;
        } catch (error) {
            console.error('Error loading eSIMs:', error);
            cachedEsims = [];
        }
    }
    /**
     * Opens user eSIMs sidebar
     */ async function openUserEsimsSidebarFunc() {
        sidebarOverlay.classList.remove('hidden');
        userEsimsSidebar.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        if (cachedEsims.length > 0) renderEsims(cachedEsims);
        else {
            userEsimsSidebarBody.innerHTML = `<div class="empty-state rounded-2"><p data-i18n="loadingEsims">Loading your eSIMs...</p></div>`;
            (0, $7xovm.default).updatePage();
            await loadUserEsims();
            if (cachedEsims.length > 0) renderEsims(cachedEsims);
            else {
                userEsimsSidebarBody.innerHTML = `<div class="empty-state rounded-2"><p data-i18n="noEsims">No eSIMs found</p></div>`;
                (0, $7xovm.default).updatePage();
            }
        }
    }
    /**
     * Closes user eSIMs sidebar
     */ function closeUserEsimsSidebarFunc() {
        userEsimsSidebar.classList.add('hidden');
        const hasOpenSidebar = !authSidebar.classList.contains('hidden') || !editProfileSidebar.classList.contains('hidden');
        if (!hasOpenSidebar) {
            sidebarOverlay.classList.add('hidden');
            document.body.style.overflow = '';
        }
    }
    /**
     * Renders eSIM cards
     * @param {Array} esims - Array of eSIM objects
     */ function renderEsims(esims) {
        if (!esims || esims.length === 0) {
            userEsimsSidebarBody.innerHTML = `<div class="empty-state"><p data-i18n="noEsims">No eSIMs found</p></div>`;
            (0, $7xovm.default).updatePage();
            return;
        }
        const template = document.getElementById('template-esim-card');
        const templateHtml = template.innerHTML;
        userEsimsSidebarBody.innerHTML = esims.map((esim)=>{
            let packageName = esim.packageList && esim.packageList.length > 0 ? esim.packageList[0].packageName : '-';
            if ((0, $7xovm.default).getLanguage() === 'es' && packageName !== '-') packageName = packageName.replace(/\bday\b/gi, "d\xeda").replace(/\bdays\b/gi, "d\xedas");
            const totalVolume = esim.totalVolume ? (0, $gGcib.formatVolume)(esim.totalVolume) : '-';
            const esimStatus = esim.esimStatus || 'pending';
            const smdpStatus = esim.smdpStatus || null;
            let combinedStatus = esimStatus;
            let combinedStatusTranslated;
            if (esimStatus === 'GOT_RESOURCE') {
                if (smdpStatus !== null) {
                    combinedStatus = smdpStatus;
                    combinedStatusTranslated = (0, $7xovm.default).t(smdpStatus) !== smdpStatus ? (0, $7xovm.default).t(smdpStatus) : smdpStatus;
                } else combinedStatusTranslated = (0, $7xovm.default).t(esimStatus) !== esimStatus ? (0, $7xovm.default).t(esimStatus) : esimStatus;
            } else if (esimStatus === 'IN_USE') {
                const usedBytes = getUsedBytes(esim);
                if (usedBytes < 500000 && !esim.installationTime) {
                    combinedStatus = 'INSTALLATION';
                    combinedStatusTranslated = (0, $7xovm.default).t('INSTALLATION');
                } else {
                    combinedStatus = esimStatus;
                    combinedStatusTranslated = (0, $7xovm.default).t(esimStatus) !== esimStatus ? (0, $7xovm.default).t(esimStatus) : esimStatus;
                }
            } else if ([
                'USED_UP',
                'USED_EXPIRED',
                'UNUSED_EXPIRED',
                'CANCEL',
                'REVOKE'
            ].includes(esimStatus)) {
                combinedStatus = esimStatus;
                combinedStatusTranslated = (0, $7xovm.default).t(esimStatus) !== esimStatus ? (0, $7xovm.default).t(esimStatus) : esimStatus;
            } else combinedStatusTranslated = (0, $7xovm.default).t(esimStatus) !== esimStatus ? (0, $7xovm.default).t(esimStatus) : esimStatus;
            let daysRemaining = 0;
            let daysText = (0, $7xovm.default).t('daysRemaining');
            if (esim.expiredTime) {
                const expiredDate = new Date(esim.expiredTime);
                const now = new Date();
                const diffTime = expiredDate - now;
                const diffDays = Math.ceil(diffTime / 86400000);
                daysRemaining = diffDays > 0 ? diffDays : 0;
                daysText = daysRemaining === 1 ? (0, $7xovm.default).t('dayRemaining') : (0, $7xovm.default).t('daysRemaining');
            }
            let smdpAddress = '';
            let activationCode = '';
            let hasManualData = false;
            if (esim.ac) {
                const acParts = esim.ac.split('$');
                if (acParts.length >= 3) {
                    smdpAddress = acParts[1] || '';
                    activationCode = acParts[2] || '';
                    hasManualData = !!(smdpAddress && activationCode);
                }
            }
            let durationUnit = esim.durationUnit || '';
            if ((0, $7xovm.default).getLanguage() === 'es' && durationUnit) durationUnit = durationUnit.replace(/\bday\b/gi, "d\xeda").replace(/\bdays\b/gi, "d\xedas");
            const isSuspended = combinedStatus === 'SUSPENDED' || smdpStatus === 'SUSPENDED';
            const packageCode = esim.packageList && esim.packageList.length > 0 ? esim.packageList[0].packageCode : null;
            let showControlButtons = false;
            if (combinedStatus === 'IN_USE' && esim.expiredTime) {
                const expiredDate = new Date(esim.expiredTime);
                const now = new Date();
                showControlButtons = expiredDate > now;
            }
            const showEsimActions = ![
                'USED_EXPIRED',
                'UNUSED_EXPIRED',
                'CANCEL',
                'REVOKE'
            ].includes(combinedStatus);
            return (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(templateHtml, {
                packageName: packageName,
                esimStatus: combinedStatus,
                esimStatusTranslated: combinedStatusTranslated,
                esimTranNo: esim.esimTranNo || '',
                orderNo: esim.orderNo || '-',
                totalVolume: totalVolume,
                orderUsage: (()=>{
                    const u = getUsedBytes(esim);
                    return u > 0 ? (0, $gGcib.formatVolume)(u) : '0';
                })(),
                totalDuration: esim.totalDuration || '-',
                durationUnit: durationUnit,
                qrCodeUrl: esim.qrCodeUrl || null,
                ac: esim.ac || null,
                daysRemaining: daysRemaining,
                daysText: daysText,
                hasManualData: hasManualData,
                smdpAddress: smdpAddress,
                activationCode: activationCode,
                apn: esim.apn || null,
                pin: esim.pin || null,
                puk: esim.puk || null,
                isSuspended: isSuspended,
                packageCode: packageCode || '',
                showControlButtons: showControlButtons,
                showEsimActions: showEsimActions
            });
        }).join('');
        (0, $7xovm.default).updatePage();
        userEsimsSidebarBody.querySelectorAll('.esim-qr-code').forEach((img)=>{
            const qrUrl = img.getAttribute('data-qr-url');
            if (qrUrl) img.src = qrUrl;
        });
        userEsimsSidebarBody.querySelectorAll('.esim-view-qr-button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
                const card = button.closest('.esim-card');
                const qrSection = card.querySelector('.esim-qr-section');
                const manualSection = card.querySelector('.esim-manual-section');
                if (qrSection) qrSection.classList.toggle('hidden');
                if (manualSection) manualSection.classList.add('hidden');
            });
        });
        userEsimsSidebarBody.querySelectorAll('.esim-manual-button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
                const card = button.closest('.esim-card');
                const manualSection = card.querySelector('.esim-manual-section');
                const qrSection = card.querySelector('.esim-qr-section');
                if (manualSection) manualSection.classList.toggle('hidden');
                if (qrSection) qrSection.classList.add('hidden');
            });
        });
        userEsimsSidebarBody.querySelectorAll('.esim-refresh-button').forEach((button)=>{
            button.addEventListener('click', async (e)=>{
                const esimTranNo = button.getAttribute('data-esim-tran-no');
                if (!esimTranNo) return;
                const card = button.closest('.esim-card');
                const dataUsageRow = Array.from(card.querySelectorAll('.esim-info-row')).find((row)=>{
                    const label = row.querySelector('.esim-label');
                    return label && label.getAttribute('data-i18n') === 'dataUsage';
                });
                const dataUsageValue = dataUsageRow ? dataUsageRow.querySelector('.esim-value') : null;
                button.disabled = true;
                button.classList.add('spin');
                try {
                    const usageResult = await provider.usage([
                        esimTranNo
                    ]);
                    if (usageResult && usageResult.usageList && usageResult.usageList.length > 0) {
                        const usage = usageResult.usageList[0];
                        if (dataUsageValue) {
                            const totalVolume = usage.totalVolume ? (0, $gGcib.formatVolume)(usage.totalVolume) : '-';
                            const usedBytes = getUsedBytes(usage);
                            const usedStr = usedBytes > 0 ? (0, $gGcib.formatVolume)(usedBytes) : '0';
                            dataUsageValue.textContent = `${usedStr} / ${totalVolume}`;
                        }
                        (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('usageUpdated'));
                    }
                } catch (error) {
                    console.error('Error refreshing usage:', error);
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || 'Failed to refresh usage');
                } finally{
                    button.disabled = false;
                    button.classList.remove('spin');
                }
            });
        });
        userEsimsSidebarBody.querySelectorAll('.esim-suspend-button').forEach((button)=>{
            button.addEventListener('click', async (e)=>{
                const esimTranNo = button.getAttribute('data-esim-tran-no');
                if (!esimTranNo) return;
                button.disabled = true;
                try {
                    const result = await provider.suspend({
                        esimTranNo: esimTranNo
                    });
                    if (result && result.code === 0) {
                        (0, $95f7cfd86f501f83$export$7774cb5a8d679f78)(esimTranNo);
                        (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('esimSuspended'));
                        await loadUserEsims();
                    } else (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(result?.message || (0, $7xovm.default).t('suspendFailed'));
                } catch (error) {
                    console.error('Error suspending eSIM:', error);
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('suspendFailed'));
                } finally{
                    button.disabled = false;
                }
            });
        });
        userEsimsSidebarBody.querySelectorAll('.esim-unsuspend-button').forEach((button)=>{
            button.addEventListener('click', async (e)=>{
                const esimTranNo = button.getAttribute('data-esim-tran-no');
                if (!esimTranNo) return;
                button.disabled = true;
                try {
                    const result = await provider.unsuspend({
                        esimTranNo: esimTranNo
                    });
                    if (result && result.code === 0) {
                        (0, $95f7cfd86f501f83$export$47ff7014d4e09111)(esimTranNo);
                        (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('esimUnsuspended'));
                        await loadUserEsims();
                    } else (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(result?.message || (0, $7xovm.default).t('unsuspendFailed'));
                } catch (error) {
                    console.error('Error unsuspending eSIM:', error);
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('unsuspendFailed'));
                } finally{
                    button.disabled = false;
                }
            });
        });
        userEsimsSidebarBody.querySelectorAll('.esim-topup-button').forEach((button)=>{
            button.addEventListener('click', async (e)=>{
                const esimTranNo = button.getAttribute('data-esim-tran-no');
                const packageCode = button.getAttribute('data-package-code');
                if (!packageCode) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('packageCodeNotFound'));
                    return;
                }
                button.disabled = true;
                const originalText = button.textContent;
                button.textContent = (0, $7xovm.default).t('loading');
                try {
                    const result = await provider.packages({
                        packageCode: packageCode,
                        type: 'TOPUP'
                    });
                    if (result && result.obj && result.obj.packageList && result.obj.packageList.length > 0) showTopupPlans(result.obj.packageList, esimTranNo);
                    else (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('noTopupPlansAvailable'));
                } catch (error) {
                    console.error('Error loading topup plans:', error);
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('errorLoadingTopupPlans'));
                } finally{
                    button.disabled = false;
                    button.textContent = originalText;
                    (0, $7xovm.default).updatePage();
                }
            });
        });
    }
    /**
     * Updates authentication UI based on user state
     */ function updateAuthUI() {
        if (account.isAuthenticated()) {
            const user = account.getCurrentUser();
            if (user && user.language) {
                (0, $7xovm.default).setLanguage(user.language);
                if (window.updateLanguageButtons) window.updateLanguageButtons();
            }
            loginButton.classList.add('hidden');
            editProfileMenuButton.classList.remove('hidden');
            logoutButton.classList.remove('hidden');
            userEsimsButton.classList.remove('hidden');
            userInfo.textContent = (0, $7xovm.default).t('hello', {
                name: user.name
            });
            userInfo.classList.remove('hidden');
            if (subtitle && user.name) {
                const subtitleText = (0, $7xovm.default).t('subtitle');
                subtitle.textContent = `${user.name}, ${subtitleText}`;
            }
            emailVerificationMessage.classList.add('hidden');
            loadUserEsims();
        } else {
            loginButton.classList.remove('hidden');
            editProfileMenuButton.classList.add('hidden');
            logoutButton.classList.add('hidden');
            userEsimsButton.classList.add('hidden');
            userInfo.classList.add('hidden');
            emailVerificationMessage.classList.add('hidden');
            if (subtitle) {
                subtitle.setAttribute('data-i18n', 'subtitle');
                (0, $7xovm.default).updatePage();
            }
        }
    }
    /**
     * Opens edit profile sidebar
     */ function openEditProfileSidebarFunc() {
        const user = account.getCurrentUser();
        if (user) {
            editProfileName.value = user.name || '';
            editProfileLastname.value = user.lastname || '';
            editProfileEmail.value = user.email || '';
            editProfileLanguage.value = user.language || (0, $7xovm.default).getLanguage();
        }
        sidebarOverlay.classList.remove('hidden');
        editProfileSidebar.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    }
    /**
     * Closes edit profile sidebar
     */ function closeEditProfileSidebarFunc() {
        editProfileSidebar.classList.add('hidden');
        const hasOpenSidebar = !authSidebar.classList.contains('hidden') || !userEsimsSidebar.classList.contains('hidden');
        if (!hasOpenSidebar) {
            sidebarOverlay.classList.add('hidden');
            document.body.style.overflow = '';
        }
        editProfileForm.reset();
    }
    /**
     * Sets up event listeners
     */ function setupEventListeners() {
        if (editProfileButton) editProfileButton.addEventListener('click', openEditProfileSidebarFunc);
        if (userEsimsButton) userEsimsButton.addEventListener('click', openUserEsimsSidebarFunc);
        resendVerificationEmailButton.addEventListener('click', async ()=>{
            try {
                resendVerificationEmailButton.disabled = true;
                await account.resendVerificationEmail();
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('verificationEmailResent'));
            } catch (error) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('verificationEmailResendFailed'));
            } finally{
                resendVerificationEmailButton.disabled = false;
            }
        });
        loginTab.addEventListener('click', (e)=>{
            e.preventDefault();
            switchToLoginTab();
        });
        registerTab.addEventListener('click', (e)=>{
            e.preventDefault();
            switchToRegisterTab();
        });
        if (loginButton) loginButton.addEventListener('click', ()=>{
            openAuthSidebarFunc();
        });
        if (editProfileMenuButton) editProfileMenuButton.addEventListener('click', ()=>{
            openEditProfileSidebarFunc();
        });
        loginForm.addEventListener('submit', async (e)=>{
            e.preventDefault();
            const email = loginEmail.value.trim();
            if (!loginEmailSent) try {
                await account.sendVerificationCode(email);
                loginEmailSent = true;
                loginEmailGroup.style.opacity = '0.5';
                loginEmailGroup.style.pointerEvents = 'none';
                loginEmail.disabled = true;
                loginCodeGroup.style.opacity = '1';
                loginCodeGroup.style.pointerEvents = 'auto';
                loginCode.disabled = false;
                loginCode.setAttribute('required', 'required');
                if (loginChangeEmailGroup) loginChangeEmailGroup.style.display = 'flex';
                loginSubmitButton.setAttribute('data-i18n', 'verifyCode');
                (0, $7xovm.default).updatePage();
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('codeSent'));
            } catch (error) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('codeSendFailed'));
            }
            else {
                const code = loginCode.value.trim();
                if (!code || code.length !== 6) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('invalidCode'));
                    return;
                }
                try {
                    await account.verifyCode(email, code);
                    const user = account.getCurrentUser();
                    if (user && user.language) {
                        (0, $7xovm.default).setLanguage(user.language);
                        if (window.updateLanguageButtons) window.updateLanguageButtons();
                    }
                    loginEmailSent = false;
                    (0, $95f7cfd86f501f83$export$682f4f7f34b277fa)();
                    closeAuthSidebarFunc(true);
                    updateAuthUI();
                    if (renderCart) renderCart();
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('loginSuccessful'));
                } catch (error) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('codeVerificationFailed'));
                }
            }
        });
        registerForm.addEventListener('submit', async (e)=>{
            e.preventDefault();
            const name = registerName.value.trim();
            const lastname = registerLastname.value.trim();
            const email = registerEmail.value.trim();
            if (!registerEmailSent) {
                if (!name || !lastname) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('nameRequired'));
                    return;
                }
                const fullName = `${name} ${lastname}`;
                try {
                    await account.sendVerificationCode(email, fullName);
                    registerEmailSent = true;
                    registerNameGroup.classList.add('hidden');
                    registerLastnameGroup.classList.add('hidden');
                    registerEmailGroup.classList.add('hidden');
                    registerCodeGroup.classList.remove('hidden');
                    registerCode.setAttribute('required', 'required');
                    registerSubmitButton.setAttribute('data-i18n', 'verifyCode');
                    (0, $7xovm.default).updatePage();
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('codeSent'));
                } catch (error) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('codeSendFailed'));
                }
            } else {
                const code = registerCode.value.trim();
                if (!code || code.length !== 6) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('invalidCode'));
                    return;
                }
                try {
                    await account.verifyCode(email, code);
                    const user = account.getCurrentUser();
                    if (user && user.language) {
                        (0, $7xovm.default).setLanguage(user.language);
                        if (window.updateLanguageButtons) window.updateLanguageButtons();
                    }
                    registerEmailSent = false;
                    (0, $95f7cfd86f501f83$export$e73d5273c65fcb57)();
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('registrationSuccessful'));
                    registerForm.reset();
                    updateAuthUI();
                    if (renderCart) renderCart();
                    setTimeout(()=>closeAuthSidebarFunc(true), 2000);
                } catch (error) {
                    (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('codeVerificationFailed'));
                }
            }
        });
        logoutButton.addEventListener('click', ()=>{
            account.logout();
            updateAuthUI();
            if (onLogout) onLogout();
        });
        if (loginChangeEmailButton) loginChangeEmailButton.addEventListener('click', ()=>{
            resetLoginForm();
        });
        editProfileForm.addEventListener('submit', async (e)=>{
            e.preventDefault();
            const user = account.getCurrentUser();
            if (!user || !user.id) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('profileUpdateFailed'));
                return;
            }
            const name = editProfileName.value.trim();
            const lastname = editProfileLastname.value.trim();
            const email = editProfileEmail.value.trim();
            const language = editProfileLanguage.value;
            if (!name || !lastname) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('nameRequired'));
                return;
            }
            if (!email) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('emailRequired'));
                return;
            }
            const profileData = {
                name: name,
                lastname: lastname,
                email: email,
                language: language
            };
            try {
                await account.updateProfile(user.id, profileData);
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('profileUpdated'));
                updateAuthUI();
                closeEditProfileSidebarFunc();
            } catch (error) {
                (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error(error.message || (0, $7xovm.default).t('profileUpdateFailed'));
            }
        });
    }
    setupEventListeners();
    checkEmailVerification();
    updateAuthUI();
    /**
     * Checks if any sidebar is open
     * @returns {boolean} True if any sidebar is open
     */ function hasOpenSidebars() {
        return !authSidebar.classList.contains('hidden') || !editProfileSidebar.classList.contains('hidden') || !userEsimsSidebar.classList.contains('hidden');
    }
    function closeAnyAuthSidebar() {
        if (loginEmailSent || registerEmailSent) return;
        if (!authSidebar.classList.contains('hidden')) closeAuthSidebarFunc();
        else if (!editProfileSidebar.classList.contains('hidden')) closeEditProfileSidebarFunc();
        else if (!userEsimsSidebar.classList.contains('hidden')) closeUserEsimsSidebarFunc();
    }
    /**
     * Sets callback functions
     * @param {Object} newCallbacks - New callback functions
     */ function setCallbacks(newCallbacks) {
        if (newCallbacks.renderCart) renderCart = newCallbacks.renderCart;
        if (newCallbacks.onLogout) onLogout = newCallbacks.onLogout;
        if (newCallbacks.store) store = newCallbacks.store;
        if (newCallbacks.showTopupPlans) showTopupPlans = newCallbacks.showTopupPlans;
    }
    return {
        openAuthSidebarFunc: openAuthSidebarFunc,
        openRegisterSidebarFunc: openRegisterSidebarFunc,
        closeAuthSidebarFunc: closeAuthSidebarFunc,
        openEditProfileSidebarFunc: openEditProfileSidebarFunc,
        closeEditProfileSidebarFunc: closeEditProfileSidebarFunc,
        closeUserEsimsSidebarFunc: closeUserEsimsSidebarFunc,
        updateAuthUI: updateAuthUI,
        checkEmailVerification: checkEmailVerification,
        hasOpenSidebars: hasOpenSidebars,
        closeAnyAuthSidebar: closeAnyAuthSidebar,
        setCallbacks: setCallbacks
    };
}



var $7xovm = parcelRequire("7xovm");

var $gGcib = parcelRequire("gGcib");
var $1b4644c68ec1b832$exports = {};
$1b4644c68ec1b832$exports = JSON.parse('["Apple iPhone 17 Pro Max","Apple iPhone 17 Pro","Apple iPhone 17 Air","Apple iPhone 17","Apple iPhone 16e","Apple iPhone 16 Pro Max","Apple iPhone 16 Plus","Apple iPhone 16 Pro","Apple iPhone 16","Apple iPhone 15 Pro Max","Apple iPhone 15 Plus","Apple iPhone 15 Pro","Apple iPhone 15","Apple iPhone 14 Pro Max","Apple iPhone 14 Plus","Apple iPhone 14 Pro","Apple iPhone 14","Apple iPhone SE 3 (2022)","Apple iPhone 13 Pro Max","Apple iPhone 13 Pro","Apple iPhone 13 Mini","Apple iPhone 13","Apple iPhone 12 Pro Max","Apple iPhone 12 Pro","Apple iPhone 12 Mini","Apple iPhone 12","Apple iPhone SE 2 (2020)","Apple iPhone 11 Pro Max","Apple iPhone 11 Pro","Apple iPhone 11","Apple iPhone XS Max","Apple iPhone XS","Apple iPhone XR","Apple iPad Pro 11\u2033 (model A2068, from 2020)","Apple iPad Pro 12.9\u2033 (model A2069, from 2020)","Apple iPad Air (model A2123, from 2019)","Apple iPad (model A2198, from 2019)","Apple iPad Mini (model A2124, from 2019)","Apple iPad 10th generation (from 2022)","Samsung Galaxy XCover7 Pro","Samsung Galaxy A56","Samsung Galaxy A55 5G","Samsung Galaxy A54 5G","Samsung Galaxy A36","Samsung Galaxy A35 5G","Samsung Galaxy A23 5G","Samsung Galaxy Z Flip5","Samsung Galaxy Z Flip6","Samsung Galaxy Z Flip 7","Samsung Galaxy Z Flip 7 FE","Samsung Galaxy Z Fold","Samsung Galaxy Z Fold3","Samsung Galaxy Z Fold5","Samsung Galaxy Z Fold6","Samsung Galaxy Z Fold7","Samsung Galaxy S25","Samsung Galaxy S25 Edge","Samsung Galaxy S25+","Samsung Galaxy S25 Ultra","Samsung Galaxy S25 Slim","Samsung Galaxy S24 Ultra","Samsung Galaxy S24+","Samsung Galaxy S24 FE","Samsung Galaxy S24","Samsung Galaxy S23 FE (not all versions are compatible with eSIMs)","Samsung Galaxy S23 Ultra","Samsung Galaxy S23+","Samsung Galaxy S23","Samsung Galaxy S22 Ultra","Samsung Galaxy S22+","Samsung Galaxy S22","Samsung Galaxy S21+ Ultra 5G","Samsung Galaxy S21+ 5G","Samsung Galaxy S21","Samsung Galaxy S20 Ultra 5G","Samsung Galaxy S20 Ultra","Samsung Galaxy S20+ 5G","Samsung Galaxy S20+","Samsung Galaxy S20","Samsung Galaxy Z Fold5 5G","Samsung Galaxy Z Fold4","Samsung Galaxy Z Fold3 5G","Samsung Galaxy Z Fold2 5G","Samsung Galaxy Fold","Samsung Galaxy Z Flip5 5G","Samsung Galaxy Z Flip4","Samsung Galaxy Z Flip3 5G","Samsung Galaxy Z Flip","Samsung Galaxy A54 (not all versions are compatible with eSIMs)","Samsung Galaxy Note 20 Ultra 5G","Samsung Galaxy Note 20","Google Pixel 10 Pro Fold","Google Pixel 10 Pro XL","Google Pixel 10 Pro","Google Pixel 10","Google Pixel 9 Pro Fold","Google Pixel 9 Pro XL","Google Pixel 9 Pro","Google Pixel 9","Google Pixel 9a","Google Pixel Fold","Google Pixel 8 Pro","Google Pixel 8","Google Pixel 8a","Google Pixel 7 Pro","Google Pixel 7","Google Pixel 7a","Google Pixel 6 Pro","Google pixel 6a","Google Pixel 6","Google Pixel 5a","Google Pixel 5","Google Pixel 4 XL","Google Pixel 4a","Google Pixel 4","Google Pixel 3a XL","Google Pixel 3a (not all versions are compatible with eSIMs)","Google Pixel 3 XL","Google Pixel 3 (not all versions are compatible with eSIMs)","Google Pixel 2 XL","Google Pixel 2 (not all versions are compatible with eSIMs)","Oppo Find X8 Pro","Oppo Find X8","Oppo Reno14 Pro","Oppo Reno14","Oppo Find N3","Oppo Find N3 Flip","Oppo Find X5 Pro","Oppo Find X5","Oppo A55s 5G","Oppo Reno 9A","Oppo Find N2 Flip","Oppo Reno 6 Pro 5G","Oppo Find X3 Pro","Oppo Find X3","Oppo Reno 5A","Xiaomi 15","Xiaomi 15 Ultra","Xiaomi 14","Xiaomi 14 Pro","Xiaomi 14T","Xiaomi 14T Pro","Xiaomi 13T","Xiaomi 13T Pro","Xiaomi 13 Pro","Xiaomi 13 Lite","Xiaomi 13","Xiaomi 12T Pro","Xiaomi Poco X7","Xiaomi Redmi Note 14 Pro","Xiaomi Redmi Note 14 Pro 5G","Xiaomi Redmi Note 14 Pro+","Xiaomi Redmi Note 14 Pro+ 5G","Xiaomi Redmi Note 13 Pro","Xiaomi Redmi Note 13 Pro+","Xiaomi Redmi Note 11 Pro 5G","Vivo X200 Pro","Vivo x200","Vivo X200s","Vivo X200 FE","Vivo X100 Pro","Vivo x90 Pro","Vivo V29 (not all versions are compatible with eSIMs)","Vivo V29 Lite 5c (not all versions are compatible with eSIMs)","vivo V40","Vivo V40 Lite (not all versions are compatible with eSIMs)","Vivo V50","OnePlus Open","OnePlus 11","OnePlus 12","OnePlus 13","OnePlus 13R","Honor Magic V3","Honor 200 Pro","Honor Magic 6 Pro","Honor Magic V2","Honor 90","Honor Magic 5 Pro","Honor X8","Honor Magic 4 Pro","Honor 400 Lite","Huawei Mate 40 Pro","Huawei P40 Pro","Huawei P40","Huawei 80 Pro / Pro+ / Ultra","Pura X foldable","Sony Xperia 10 III Lite","Sony Xperia 10 VI","Sony Xperia 10 V","Sony Xperia 10 IV","Sony Xperia 1 VI","Sony Xperia 1 V","Sony Xperia 1 IV","Sony Xperia 5 IV","Sony Xperia Ace III","Sony Xperia 5 V","Sony Xperia 1 VII","Motorola Edge 60","Motorola Edge 60 Pro","Motorola Edge 60 Fusion","Motorola Edge 60 Stylus","Motorola Edge 50","Motorola Edge 50 Fusion","Motorola Edge 50 Pro","Motorola Edge 50 Neo","Motorola Edge 50 Ultra","Motorola Edge 40 Neo","Motorola Edge 40 Pro","Motorola Edge 40","Motorola Edge+","Motorola Edge+ (2023)","Motorola Edge (2024)","Motorola Edge (2023)","Motorola Edge (2022)","Motorola Razr 40","Motorola Razr 40 Ultra","Motorola Razr 60","Motorola Razr 50","Motorola Razr 50 Ultra","Motorola Razr 2024","Motorola Razr+ 2024","Motorola Razr 2022","Motorola Razr 2019","Motorola Razr 5G","Motorola ThinkPhone 25","Sharp AQUOS sense4 lite","Sharp AQUOS Sense6s","AQUOS sense 7","AQUOS sense 7plus","Sharp AQUOS Wish","AQUOS wish 2 SHG08","AQUOS wish3","AQUOS zero 6","Simple Sumaho6","Sharp AQUOS R7","Sharp AQUOS R8","Sharp AQUOS R8 Pro","Sharp Aquos sense8","Rakuten Mini","Rakuten Big-S","Rakuten Big","Rakuten Hand","Rakuten Hand 5G","Tcl 60","Tcl 60 XE NxtPaper","Tcl 50 5G","Tcl 50 NxtPaper","Tcl 50 Pro NxtPaper","Tcl 40 XL","Gemini PDA","Fairphone 4","Fairphone 5","DOOGEE V30","OnePlus Open","OnePlus 11","OnePlus 12","OnePlus 13","OnePlus 13R","HAMMER Blade 3","HAMMER Explorer PRO","HAMMER Blade 5G","Nokia XR21","Nokia X30","Nokia G60 5G","myPhone NOW eSIM","OUKITEL WP30 Pro","OUKITEL WP33 Pro","Nuu X5","ZTE Nubia Flip","TLC 50 5G","Asus ROG Phone 9","Asus ROG Phone 9 Pro","Realme 14 Pro+","Realme GT 7","Asus ROG Phone 9","Asus ROG Phone 9 Pro","Asus Zenfone 12 Ultra","Samsung Galaxy S20 FE 4G/5G (not compatible)","Samsung S20/S21 (US versions not compatible)","Galaxy Z Flip 5G (US versions not compatible)","Samsung Note 20 Ultra (Versions from the US and Hong Kong not compatible)","Samsung Galaxy Z Fold 2 (Versions from the US and Hong Kong not compatible)","Google Pixel 3 devices from Australia, Japan, and Taiwan (not compatible)","Samsung Galaxy S10 (not compatible)","Huawei P40 Pro+ (not compatible)","Xiaomi 12T (not compatible)"]');


/**
 * Compatibility checker for devices
 */ class $8a87b76d5cf26e34$var$CompatibilityChecker {
    constructor(){
        this.devices = (0, (/*@__PURE__*/$parcel$interopDefault($1b4644c68ec1b832$exports))) || [];
    }
    /**
     * Searches devices by name
     * @param {string} query - Search query
     * @returns {Array<string>} Array of matching device names (max 10)
     */ searchDevices(query) {
        if (!query || query.length < 1) return [];
        const normalizedQuery = (0, $gGcib.normalizeText)(query);
        const queryParts = normalizedQuery.split(' ').filter((part)=>part.length > 0);
        return this.devices.filter((device)=>{
            const normalizedDevice = (0, $gGcib.normalizeText)(device);
            return queryParts.every((part)=>normalizedDevice.includes(part));
        }).slice(0, 10);
    }
    /**
     * Checks if a device is compatible
     * @param {string} deviceName - Device name to check
     * @returns {Object} { compatible: boolean, device: string, message: string }
     */ checkCompatibility(deviceName) {
        if (!deviceName) return {
            compatible: false,
            device: null,
            message: null
        };
        const normalizedDevice = (0, $gGcib.normalizeText)(deviceName);
        const device = this.devices.find((d)=>(0, $gGcib.normalizeText)(d) === normalizedDevice);
        if (!device) return {
            compatible: false,
            device: null,
            message: (0, $7xovm.default).t('deviceNotFound')
        };
        const isNotCompatible = device.toLowerCase().includes('not compatible');
        return {
            compatible: !isNotCompatible,
            device: device,
            message: isNotCompatible ? (0, $7xovm.default).t('deviceNotCompatible') : (0, $7xovm.default).t('deviceCompatible')
        };
    }
}
const $8a87b76d5cf26e34$var$compatibilityChecker = new $8a87b76d5cf26e34$var$CompatibilityChecker();
var $8a87b76d5cf26e34$export$2e2bcd8739ae039 = $8a87b76d5cf26e34$var$compatibilityChecker;



var $gGcib = parcelRequire("gGcib");



const $35da740d59af89ba$var$provider = new (0, $42f96fa8e433dde8$export$2e2bcd8739ae039)();
const $35da740d59af89ba$var$store = new (0, $720883cc9bd4d85c$export$2e2bcd8739ae039)($35da740d59af89ba$var$provider);
const $35da740d59af89ba$var$account = new (0, $e1fc32ee47c23d00$export$2e2bcd8739ae039)();
// Login by link: if URL has ?itoken=..., save as session (e.g. from admin) and clean URL
(function checkLoginByLink() {
    if (typeof $35da740d59af89ba$var$account.loginWithToken !== 'function') return;
    const params = new URLSearchParams(window.location.search);
    const token = params.get('itoken');
    if (token && $35da740d59af89ba$var$account.loginWithToken(token)) {
        params.delete('itoken');
        const search = params.toString();
        const cleanUrl = window.location.pathname + (search ? '?' + search : '') + window.location.hash;
        window.history.replaceState({}, '', cleanUrl);
    }
})();
const $35da740d59af89ba$var$sidebarOverlay = document.getElementById('sidebarOverlay');
const $35da740d59af89ba$var$cartSidebar = document.getElementById('cartSidebar');
const $35da740d59af89ba$var$cartToggleButton = document.getElementById('cartToggleButton');
const $35da740d59af89ba$var$cartBody = document.getElementById('cartBody');
const $35da740d59af89ba$var$cartBuyButton = document.getElementById('cartBuyButton');
const $35da740d59af89ba$var$cartBadge = document.getElementById('cartBadge');
const $35da740d59af89ba$var$packageDetailsSidebar = document.getElementById('packageDetailsSidebar');
const $35da740d59af89ba$var$compatibilitySidebar = document.getElementById('compatibilitySidebar');
const $35da740d59af89ba$var$compatibilityToggleButton = document.getElementById('compatibilityToggleButton');
const $35da740d59af89ba$var$installationSidebar = document.getElementById('installationSidebar');
const $35da740d59af89ba$var$installationToggleButton = document.getElementById('installationToggleButton');
const $35da740d59af89ba$var$authMain = (0, $0fc4247925ff5a5f$export$6d3c879d7a79980d)($35da740d59af89ba$var$account, {
    sidebarOverlay: $35da740d59af89ba$var$sidebarOverlay
}, {
    renderCart: null,
    onLogout: null
});
const $35da740d59af89ba$var$cartUI = (0, $b86113196e618a42$export$e838c4b04241f74)($35da740d59af89ba$var$store.cart, {
    cartSidebar: $35da740d59af89ba$var$cartSidebar,
    cartToggleButton: $35da740d59af89ba$var$cartToggleButton,
    cartBody: $35da740d59af89ba$var$cartBody,
    cartBuyButton: $35da740d59af89ba$var$cartBuyButton,
    cartBadge: $35da740d59af89ba$var$cartBadge,
    sidebarOverlay: $35da740d59af89ba$var$sidebarOverlay
}, {
    account: $35da740d59af89ba$var$account,
    onCheckout: async (cartItems)=>{
        const currentUser = $35da740d59af89ba$var$account.getCurrentUser();
        const baseUrl = (0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).api.checkout;
        const response = await fetch(baseUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: currentUser?.id || null,
                userEmail: currentUser?.email || null,
                items: cartItems.map((item)=>({
                        packageCode: item.packageCode,
                        price: item.price,
                        quantity: item.quantity,
                        name: item.name,
                        ...item.esimTranNo && {
                            esimTranNo: item.esimTranNo
                        }
                    }))
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.details || errorData.error || 'Failed to create checkout session');
        }
        const session = await response.json();
        if (session.error) throw new Error(session.details || session.error);
        if (session.url) window.location.href = session.url;
        else if (session.id) window.location.href = `https://checkout.stripe.com/c/pay/${session.id}`;
        else throw new Error('No checkout URL or session ID received from server');
    },
    onOpenRegister: ()=>{
        return true;
    },
    checkOtherSidebars: ()=>{
        return !$35da740d59af89ba$var$packageDetailsSidebar.classList.contains('hidden') || $35da740d59af89ba$var$authMain.hasOpenSidebars();
    }
});
const $35da740d59af89ba$var$esimMain = (0, $edd17143013384ea$export$bbbeede16db65336)($35da740d59af89ba$var$store, {
    sidebarOverlay: $35da740d59af89ba$var$sidebarOverlay
}, {
    renderCart: ()=>$35da740d59af89ba$var$cartUI.renderCart(),
    openCart: ()=>$35da740d59af89ba$var$cartUI.openCart()
});
$35da740d59af89ba$var$authMain.setCallbacks({
    renderCart: ()=>$35da740d59af89ba$var$cartUI.renderCart(),
    onLogout: ()=>{
        $35da740d59af89ba$var$cartUI.renderCart();
    },
    store: $35da740d59af89ba$var$store,
    showTopupPlans: $35da740d59af89ba$var$esimMain.showTopupPlans
});
document.addEventListener('click', (e)=>{
    if (e.target.closest('.sidebar-close')) {
        const closeButton = e.target.closest('.sidebar-close');
        const sidebar = closeButton.closest('.sidebar');
        if (!sidebar) return;
        const sidebarId = sidebar.id;
        if (sidebarId === 'cartSidebar') $35da740d59af89ba$var$cartUI.closeCart();
        else if (sidebarId === 'packageDetailsSidebar') {
            $35da740d59af89ba$var$esimMain.closePackageDetailsSidebarFunc();
            const hasOpenSidebar = !$35da740d59af89ba$var$cartSidebar.classList.contains('hidden') || $35da740d59af89ba$var$authMain.hasOpenSidebars();
            if (!hasOpenSidebar) {
                $35da740d59af89ba$var$sidebarOverlay.classList.add('hidden');
                document.body.style.overflow = '';
            }
        } else if (sidebarId === 'authSidebar') $35da740d59af89ba$var$authMain.closeAuthSidebarFunc(true);
        else if (sidebarId === 'userEsimsSidebar') $35da740d59af89ba$var$authMain.closeUserEsimsSidebarFunc();
        else if (sidebarId === 'editProfileSidebar') $35da740d59af89ba$var$authMain.closeEditProfileSidebarFunc();
        else if (sidebarId === 'compatibilitySidebar') $35da740d59af89ba$var$closeCompatibilitySidebar();
        else if (sidebarId === 'installationSidebar') $35da740d59af89ba$var$closeInstallationSidebar();
    }
});
$35da740d59af89ba$var$sidebarOverlay.addEventListener('click', (e)=>{
    if (!$35da740d59af89ba$var$cartSidebar.classList.contains('hidden')) $35da740d59af89ba$var$cartUI.closeCart();
    else if (!$35da740d59af89ba$var$packageDetailsSidebar.classList.contains('hidden')) {
        $35da740d59af89ba$var$esimMain.closePackageDetailsSidebarFunc();
        const hasOpenSidebar = !$35da740d59af89ba$var$cartSidebar.classList.contains('hidden') || $35da740d59af89ba$var$authMain.hasOpenSidebars();
        if (!hasOpenSidebar) {
            $35da740d59af89ba$var$sidebarOverlay.classList.add('hidden');
            document.body.style.overflow = '';
        }
    } else if ($35da740d59af89ba$var$authMain.hasOpenSidebars()) $35da740d59af89ba$var$authMain.closeAnyAuthSidebar();
    else if (!$35da740d59af89ba$var$compatibilitySidebar.classList.contains('hidden')) $35da740d59af89ba$var$closeCompatibilitySidebar();
    else if (!$35da740d59af89ba$var$installationSidebar.classList.contains('hidden')) $35da740d59af89ba$var$closeInstallationSidebar();
});
function $35da740d59af89ba$var$checkStripeRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    const pathname = window.location.pathname;
    // Check for cancel route
    if (pathname === '/cancel') {
        window.history.replaceState({}, document.title, '/');
        const cartItems = $35da740d59af89ba$var$store.cart.getCart();
        if (cartItems.length > 0) (0, $95f7cfd86f501f83$export$649d4077baf59467)(cartItems);
        (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error((0, $7xovm.default).t('paymentCanceled'));
        return;
    }
    // Check for success route with session_id
    if (pathname === '/success' && sessionId) {
        window.history.replaceState({}, document.title, '/');
        const cartItems = $35da740d59af89ba$var$store.cart.getCart();
        const totalValue = cartItems.reduce((sum, item)=>{
            return sum + parseFloat(item.price) * item.quantity;
        }, 0);
        (0, $95f7cfd86f501f83$export$c0440a6856e748cf)(sessionId, cartItems, totalValue);
        $35da740d59af89ba$var$store.clearCart();
        $35da740d59af89ba$var$cartUI.renderCart();
        // Toast permanente (duration = 0 significa que no se cierra automáticamente)
        (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('paymentSuccessful'), 0);
    }
}
function $35da740d59af89ba$var$initCompatibilityChecker() {
    const deviceSearchInput = document.getElementById('deviceSearch');
    const deviceDropdown = document.getElementById('deviceAutocompleteDropdown');
    const deviceResults = document.getElementById('deviceSearchResults');
    if (!deviceSearchInput || !deviceDropdown || !deviceResults) return;
    let searchTimeout;
    deviceSearchInput.addEventListener('input', (e)=>{
        const query = e.target.value.trim();
        clearTimeout(searchTimeout);
        if (query.length < 2) {
            (0, $gGcib.hideDropdown)(deviceDropdown);
            deviceResults.classList.add('hidden');
            return;
        }
        searchTimeout = setTimeout(()=>{
            const matches = (0, $8a87b76d5cf26e34$export$2e2bcd8739ae039).searchDevices(query);
            if (matches.length > 0) {
                renderDeviceDropdown(matches);
                deviceDropdown.classList.remove('hidden');
            } else (0, $gGcib.hideDropdown)(deviceDropdown);
        }, 300);
    });
    deviceSearchInput.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            const query = e.target.value.trim();
            if (query.length >= 2) checkDeviceCompatibility(query);
        }
    });
    document.addEventListener('click', (e)=>{
        if (!deviceSearchInput.contains(e.target) && !deviceDropdown.contains(e.target)) (0, $gGcib.hideDropdown)(deviceDropdown);
    });
    function renderDeviceDropdown(devices) {
        deviceDropdown.innerHTML = devices.map((device)=>`
            <div class="autocomplete-item d-flex align-items-center gap-2 p-2" data-device="${device}">
                <i class="bi bi-phone"></i>
                <div class="autocomplete-item-content flex-1">
                    <div class="autocomplete-item-name">${device}</div>
                </div>
            </div>
        `).join('');
        deviceDropdown.querySelectorAll('.autocomplete-item').forEach((item)=>{
            item.addEventListener('click', ()=>{
                const device = item.dataset.device;
                deviceSearchInput.value = device;
                (0, $gGcib.hideDropdown)(deviceDropdown);
                checkDeviceCompatibility(device);
            });
        });
    }
    function checkDeviceCompatibility(deviceName) {
        const result = (0, $8a87b76d5cf26e34$export$2e2bcd8739ae039).checkCompatibility(deviceName);
        renderDeviceResult(result);
    }
    function renderDeviceResult(result) {
        if (!result.device) deviceResults.innerHTML = `
                <div class="device-result-card rounded-2">
                    <div class="device-result-message text-gray mt-1">${result.message || (0, $7xovm.default).t('deviceNotFound')}</div>
                </div>
            `;
        else {
            const statusClass = result.compatible ? 'compatible' : 'not-compatible';
            const statusText = result.compatible ? (0, $7xovm.default).t('deviceCompatible') : (0, $7xovm.default).t('deviceNotCompatible');
            deviceResults.innerHTML = `
                <div class="device-result-card rounded-2 ${statusClass} mb-2">
                    <div class="device-result-header mb-1">
                        <div class="device-result-name">${result.device}</div>
                        <div class="device-result-status rounded-2 ${statusClass}">${statusText}</div>
                    </div>
                    <div class="device-result-message text-gray mt-1">${result.message}</div>
                </div>
            `;
        }
        deviceResults.classList.remove('hidden');
    }
}
function $35da740d59af89ba$var$openCompatibilitySidebar() {
    $35da740d59af89ba$var$compatibilitySidebar.classList.remove('hidden');
    $35da740d59af89ba$var$sidebarOverlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
}
function $35da740d59af89ba$var$closeCompatibilitySidebar() {
    $35da740d59af89ba$var$compatibilitySidebar.classList.add('hidden');
    const hasOpenSidebar = !$35da740d59af89ba$var$cartSidebar.classList.contains('hidden') || !$35da740d59af89ba$var$packageDetailsSidebar.classList.contains('hidden') || $35da740d59af89ba$var$authMain.hasOpenSidebars();
    if (!hasOpenSidebar) {
        $35da740d59af89ba$var$sidebarOverlay.classList.add('hidden');
        document.body.style.overflow = '';
    }
}
if ($35da740d59af89ba$var$compatibilityToggleButton) $35da740d59af89ba$var$compatibilityToggleButton.addEventListener('click', (e)=>{
    e.preventDefault();
    $35da740d59af89ba$var$openCompatibilitySidebar();
});
function $35da740d59af89ba$var$openInstallationSidebar() {
    $35da740d59af89ba$var$installationSidebar.classList.remove('hidden');
    $35da740d59af89ba$var$sidebarOverlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
}
function $35da740d59af89ba$var$closeInstallationSidebar() {
    $35da740d59af89ba$var$installationSidebar.classList.add('hidden');
    const hasOpenSidebar = !$35da740d59af89ba$var$cartSidebar.classList.contains('hidden') || !$35da740d59af89ba$var$packageDetailsSidebar.classList.contains('hidden') || !$35da740d59af89ba$var$compatibilitySidebar.classList.contains('hidden') || $35da740d59af89ba$var$authMain.hasOpenSidebars();
    if (!hasOpenSidebar) {
        $35da740d59af89ba$var$sidebarOverlay.classList.add('hidden');
        document.body.style.overflow = '';
    }
}
if ($35da740d59af89ba$var$installationToggleButton) $35da740d59af89ba$var$installationToggleButton.addEventListener('click', (e)=>{
    e.preventDefault();
    $35da740d59af89ba$var$openInstallationSidebar();
});
const $35da740d59af89ba$var$languageEsButton = document.getElementById('languageEs');
const $35da740d59af89ba$var$languageEnButton = document.getElementById('languageEn');
function $35da740d59af89ba$var$updateLanguageButtons() {
    const currentLang = (0, $7xovm.default).getLanguage();
    if ($35da740d59af89ba$var$languageEsButton && $35da740d59af89ba$var$languageEnButton) {
        $35da740d59af89ba$var$languageEsButton.classList.remove('active');
        $35da740d59af89ba$var$languageEnButton.classList.remove('active');
        if (currentLang === 'es') $35da740d59af89ba$var$languageEsButton.classList.add('active');
        else $35da740d59af89ba$var$languageEnButton.classList.add('active');
    }
}
window.updateLanguageButtons = $35da740d59af89ba$var$updateLanguageButtons;
if ($35da740d59af89ba$var$languageEsButton) $35da740d59af89ba$var$languageEsButton.addEventListener('click', async ()=>{
    (0, $7xovm.default).setLanguage('es');
    (0, $95f7cfd86f501f83$export$722ffa05901529f6)('es');
    $35da740d59af89ba$var$updateLanguageButtons();
    if ($35da740d59af89ba$var$esimMain && $35da740d59af89ba$var$esimMain.loadCountries) await $35da740d59af89ba$var$esimMain.loadCountries();
    if ($35da740d59af89ba$var$esimMain && $35da740d59af89ba$var$esimMain.refreshCurrentSections) $35da740d59af89ba$var$esimMain.refreshCurrentSections();
    if ($35da740d59af89ba$var$cartUI && $35da740d59af89ba$var$cartUI.renderCart) $35da740d59af89ba$var$cartUI.renderCart();
});
if ($35da740d59af89ba$var$languageEnButton) $35da740d59af89ba$var$languageEnButton.addEventListener('click', async ()=>{
    (0, $7xovm.default).setLanguage('en');
    (0, $95f7cfd86f501f83$export$722ffa05901529f6)('en');
    $35da740d59af89ba$var$updateLanguageButtons();
    if ($35da740d59af89ba$var$esimMain && $35da740d59af89ba$var$esimMain.loadCountries) await $35da740d59af89ba$var$esimMain.loadCountries();
    if ($35da740d59af89ba$var$esimMain && $35da740d59af89ba$var$esimMain.refreshCurrentSections) $35da740d59af89ba$var$esimMain.refreshCurrentSections();
    if ($35da740d59af89ba$var$cartUI && $35da740d59af89ba$var$cartUI.renderCart) $35da740d59af89ba$var$cartUI.renderCart();
});
$35da740d59af89ba$var$updateLanguageButtons();
const $35da740d59af89ba$var$currentYearElement = document.getElementById('currentYear');
if ($35da740d59af89ba$var$currentYearElement) $35da740d59af89ba$var$currentYearElement.textContent = new Date().getFullYear();
const $35da740d59af89ba$var$supportEmailElement = document.getElementById('supportEmail');
if ($35da740d59af89ba$var$supportEmailElement) $35da740d59af89ba$var$supportEmailElement.addEventListener('click', async (e)=>{
    e.preventDefault();
    const email = 'support@ilovej1.com';
    try {
        await navigator.clipboard.writeText(email);
        (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('emailCopied'));
    } catch (error) {
        // Fallback para navegadores que no soportan clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = email;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).success((0, $7xovm.default).t('emailCopied'));
        } catch (err) {
            console.error('Failed to copy email:', err);
            (0, $77fa8ab1aa12d8fb$export$2e2bcd8739ae039).error('Failed to copy email');
        } finally{
            document.body.removeChild(textArea);
        }
    }
});
// FAQ Toggle functionality
const $35da740d59af89ba$var$faqQuestions = document.querySelectorAll('.faq-question');
$35da740d59af89ba$var$faqQuestions.forEach((question)=>{
    question.addEventListener('click', ()=>{
        const faqItem = question.closest('.faq-item');
        const faqAnswer = faqItem.querySelector('.faq-answer');
        const isActive = faqItem.classList.contains('active');
        const faqNumber = question.getAttribute('data-faq');
        // Close all other FAQ items
        document.querySelectorAll('.faq-item').forEach((item)=>{
            if (item !== faqItem) {
                item.classList.remove('active');
                item.querySelector('.faq-answer').classList.add('hidden');
            }
        });
        // Toggle current FAQ item
        if (isActive) {
            faqItem.classList.remove('active');
            faqAnswer.classList.add('hidden');
        } else {
            faqItem.classList.add('active');
            faqAnswer.classList.remove('hidden');
            if (faqNumber) (0, $95f7cfd86f501f83$export$d3f3b943f53ff6ce)(parseInt(faqNumber));
        }
    });
});
(0, $7xovm.default).updatePage();
$35da740d59af89ba$var$checkStripeRedirect();
$35da740d59af89ba$var$initCompatibilityChecker();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', (0, $gGcib.adjustBodyBackgroundSize));
else (0, $gGcib.adjustBodyBackgroundSize)();
let $35da740d59af89ba$var$resizeTimeout;
window.addEventListener('resize', ()=>{
    clearTimeout($35da740d59af89ba$var$resizeTimeout);
    $35da740d59af89ba$var$resizeTimeout = setTimeout((0, $gGcib.adjustBodyBackgroundSize), 100);
});
window.addEventListener('orientationchange', ()=>{
    setTimeout((0, $gGcib.adjustBodyBackgroundSize), 100);
});


//# sourceMappingURL=workspace.5fcf2408.js.map
